export const enLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: 'Playing {index} of {count}',
    chapters: 'Chapters',
    transcript: 'Transcript',
    membersOnly: 'Members only',
    live: 'LIVE',
    upcoming: 'Upcoming',
    lessonOf: 'Lesson {index} of {count}',
    days: 'days',
    hours: 'hrs',
    minutes: 'min',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: 'All',
    asked: 'Asked',
    answered: 'Answered',
    buy: 'Buy',
    resume: 'Resume',
    watched: '{count} of {total} watched',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: 'Playing',
    mediaPlaceholder: 'Image or video',
    badgeHint: 'Badge',
  },
  slider: {
    image: 'Image',
    before: 'Before',
    after: 'After',
  },
  wrongPage: {
    noItem: 'There is no such item on this page',
    noBlock: 'There is no such block on this page',
    question: 'Go to the page with this block?',
    goToPage: 'Go to page',
  },
  common: {
    lauching: 'Launching',
    showMore: 'Show more',
    share: 'Share',
  },
  bio: {
    expand: 'See more',
  },
  timer: {
    days: 'Days',
    hours: 'Hours',
    min: 'Minutes',
    sec: 'Seconds',
  },
  form: {
    email: 'Email',
    name: 'Name',
    phone: 'Phone',
    comment: 'Comment (optional)',
    address: 'Address',
    insta: 'Instagram account',
    submitEmail: 'We sent information to your email',
    total: 'Total',
    firstName: 'First Name',
    lastName: 'Last Name',
    enterName: 'First and Last Name',
    enterEmail: 'Email',
    enterAddress: 'Address',
    enterComment: 'Wripe Comment (optional)',
    thankYou: 'Thank you!',
    error: 'Something went wrong',
    successEmail: 'Your email has been successfully submitted',
    successPhone: 'Your phone has been successfully submitted',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: 'Step {current} of {total}',
    back: 'Back',
    next: 'Next',
    day: 'Day',
    time: 'Time',
    chooseFile: 'Choose a file',
    uploading: 'Uploading…',
    uploaded: 'uploaded',
    uploadFailed: 'upload failed',
    uploadTooLarge: 'too large',
    uploadLimit: 'up to {size} MB',
    removeFile: 'Remove',
    sending: 'Sending…',
    sentTitle: 'Message sent',
    sendAnother: 'Send another',
    closedTitle: 'Submissions are closed',
    closedText: '',
  },
  basket: {
    addItem: 'Add to cart',
    itemAdded: 'Added to the cart',
    orderNow: 'Order Now',
    goToCart: 'Go to the cart',
    continue: 'Continue shopping',
    shoppingCart: 'Shopping cart',
    submitOrder: 'Submit order',
    cancel: 'Cancel',
    items: 'Items',
    total: 'Total',
    shipping: 'Shipping',
    shippingName: 'Enter First and Last Name',
    shippingEmail: 'Enter Email',
    shippingAddress: 'Enter Address',
    shippingComment: 'Enter Comment (optional)',
    paymentMethod: 'Payment Method',
    stripe: 'Pay with Stripe',
    wayforpay: 'Debit or Credit Card',
    cash: 'Cash',
    buttonProcessOrder: 'Process your order',
    titleEmpty: 'Your Cart is Empty',
    subtitleEmpty: "Looks like you haven't added anything to your cart yet",
    bthShopNow: 'Shop Now',
    successOrder: 'Your order was successfully submitted!',
    errorOrder: 'Your order was not submitted',
    bthHome: 'Go to Home',
    quantity: 'Qty',
  },
  contacts: {
    ask: 'Ask in',
    orderWhatsApp: 'Order on WhatsApp',
  },
  // The `scroll` template's swipe hint and the default text of its per-card button.
  features: {
    swipe: 'Swipe',
    more: 'Learn more',
  },
  // Wording the Team templates draw around the people the owner added.
  team: {
    getInTouch: 'Get in touch',
    profile: 'Profile',
    people: 'people',
    swipe: 'Swipe',
    otherPeople: 'Also here',
  },
  donation: {
    textBuy: 'Buy',
    fieldComment: 'Say something nice...(optional)',
    buttonSupport: 'Support',
  },
  category: {
    all: 'All',
    noItems: 'No items',
  },
  // Reading time, the filter chips and the archive's disclosure button.
  blog: {
    read: 'Read',
    min: 'min',
    minRead: 'min read',
    all: 'All',
    pinned: 'Pinned',
    showMore: 'Show more',
  },
  // The `search` template's empty state — questions wording, not the shop's "No items".
  faq: {
    noResults: 'Nothing matches that search',
  },
  // The Overview block's twelve templates all print the same live open/closed line.
  // `{time}`, `{minutes}` and `{day}` are filled by OverviewUI/utils/status.js.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  // The chat's own furniture — the input placeholder, the failure line, the default buttons.
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Ask anything...',
      continueChat: 'Continue chat',
      noResponse: 'No response',
      sendError: 'Something went wrong. Please try again.',
      defaultBubbleTitle: 'AI Chat',
      launchLabel: 'Start the conversation',
      startChatLabel: 'Start a chat',
    },
  },
  link: {
    visitLink: 'Visit Link',
  },
  map: {
    directions: 'Get directions',
    copyAddress: 'Copy address',
    call: 'Call',
    deliveryAddress: 'Enter your address',
    deliveryCheck: 'Check the distance',
    searchPoint: 'Find the nearest location',
  },
  gallery: {
    photos: 'photos',
    photo: 'photo',
    all: 'All',
    open: 'Open',
    openGallery: 'Open the gallery',
  },
  pageList: {
    navigation: 'Navigation',
    previous: 'Previous',
    next: 'Next',
    allPages: 'All pages of this section',
  },
  footer: {
    subscribe: 'Subscribe',
    subscribed: 'Thanks — you are on the list.',
    emailPlaceholder: 'you@email.com',
    app: 'App',
    payment: 'Payment',
    language: 'Language',
    currencyAndShipping: 'Currency and shipping',
    messengers: 'Messengers',
  },
  error: {
    correctEmail: 'Enter correct email',
    emptyField: 'field cannot be empty',
  },
  sort: {
    title: 'Sort',
    search: 'Search',
    default: 'Default sorting',
    dateNew: 'Date: Newest to Oldest',
    dateOld: 'Date: Oldest to Newest',
    priceLow: 'Price: Low to High',
    priceHigh: 'Price: High to Low',
    nameA: 'Name: A to Z',
    nameZ: 'Name: Z to A',
  },
  shop: {
    notify: 'Notify me',
    itemsLeft: 'items left',
    notAvailable: 'Not available',
    available: 'Available',
    similar: 'You may also like',
    similarEmpty: 'Similar products not found',
    oldPriceLabel: 'Old price',
    salePriceLabel: 'Sale price',
    saleBadge: 'Sale',
  },
  file: {
    download: 'Download',
    get: 'Get',
    current: 'Current',
    files: 'files',
    gateTitle: 'Get the file',
    gateText: 'Leave your email and the download opens right here.',
    gateAction: 'Show me the file',
    gateNote: 'Your email only goes to the owner of this page.',
    largeFile: 'Large download — Wi-Fi recommended.',
    startDownload: 'Start download',
    kindDocument: 'Documents',
    kindImage: 'Images',
    kindVideo: 'Video',
    kindAudio: 'Audio',
    kindArchive: 'Archives',
    kindOther: 'Other files',
  },
  music: {
    play: 'Play',
    pause: 'Pause',
    previous: 'Previous',
    next: 'Next',
    listen: 'Listen',
    listenOn: 'Listen on',
    download: 'Download',
    presave: 'Pre-save',
    buy: 'Buy',
    on: 'on',
    tracksCount: 'tracks',
    tracklist: 'Tracklist',
    upNext: 'Up next',
    newSingle: 'New single',
    addToBasket: 'Add to basket',
    preview: 'preview',
    hoursShort: 'h',
    minutesShort: 'min',
    emptyTracks: 'No tracks yet',
    emptyReleases: 'No releases yet',
    emptyReleaseLinks: 'No streaming links yet',
    emptyPlaylists: 'No playlists yet',
  },
  podcast: {
    play: 'Play',
    pause: 'Pause',
    playEpisode: 'Play episode',
    playTrailer: 'Play trailer',
    listen: 'Listen',
    watch: 'Watch',
    latest: 'Latest',
    guest: 'Guest',
    guests: 'Guests',
    moreGuests: 'More guests',
    moreGuestsCaption: 'See the full season',
    hostedBy: 'Hosted by',
    subscribe: 'Subscribe',
    episodes: 'episodes',
    allEpisodes: 'All episodes',
    addToQueue: 'Play all from here',
    left: 'left',
    mentioned: 'Mentioned',
    transcript: 'Transcript',
    clip: 'Clip',
    shareClip: 'Share this clip',
    share: 'Share',
    speed: 'Playback speed',
    back15: 'Back 15 seconds',
    forward30: 'Forward 30 seconds',
    askTitle: 'Ask us anything',
    sendQuestion: 'Send question',
    recordQuestion: 'Record a voice question',
    leaveReview: 'Leave a review',
    supportTitle: 'Support the show',
    becomeSupporter: 'Become a supporter',
    bestOfTitle: 'New here? Start with these',
    bestOfText: 'Episodes people send to their friends',
    emptyEpisodes: 'No episodes yet',
    emptyShows: 'No shows yet',
    emptyShowLinks: 'Add the apps this show is on',
    emptyChapters: 'Write timestamped lines in the episode notes to get chapters',
    emptyTranscript: 'Paste a transcript into the episode notes as "0:00 Name: line"',
    emptyClip: 'Add episode notes — the first sentence becomes the quote',
    emptyResume: 'Nothing started yet',
    emptyHosts: 'Name the host on an episode to fill this card',
    emptyGuests: 'Name a guest on an episode to fill this card',
    emptyTopics: 'Give the shows a category to filter by topic',
    emptyAsk: 'Add the prompt and where the answers go',
    emptyRating: 'Add your rating and a review to quote',
    emptySupport: 'Add your supporter tiers',
  },
  // The visitor's side of messaging: the "message me" modal, the floating button and the live
  // chat's audience checkbox. {name} is the page owner.
  messaging: {
    floatingButton: 'Message me',
    title: 'Message {name}',
    subtitle: 'Send a message straight to {name}.',
    faqTitle: 'Before you ask',
    namePlaceholder: 'Your name (optional)',
    contactPlaceholder: 'Email or phone number',
    messagePlaceholder: 'Message',
    consent: "Add me to {name}'s audience",
    signedInHint: '{name} will get your account email so they can reply.',
    send: 'Send',
    close: 'Close',
    sentTitle: 'Message sent',
    sentSubtitle: '{name} has your message.',
    errorGeneric: "Your message wasn't sent. Check your connection and try again.",
    errorRateLimit: "You've sent several messages in a short time. Try again in an hour.",
    errorDisabled: "{name} isn't accepting messages right now.",
    errorTooLong: 'This is too long — shorten the message and try again.',
    errorContactRequired: 'Add an email or phone number so {name} can reply.',
    errorEmpty: 'Write a message first.',
    // Pay-gate and tips. {price} is the amount with its currency code, e.g. "5 USD".
    priceLine: '{price} · reply within {days} or automatic refund',
    daysOne: '1 day',
    daysOther: '{count} days',
    emailPlaceholder: 'Your email',
    emailRequiredHint: 'Paid messages are answered by email, so use your email address.',
    sendPaid: 'Pay {price} and send',
    tipTitle: 'Add a tip (optional)',
    tipNone: 'No tip',
    tipNotStarted: "The tip payment couldn't start, but your message was sent.",
    paidSentTitle: 'Payment received',
    paidSentSubtitle: '{name} will reply by email within {days}.',
    tipSentTitle: 'Thanks for the tip!',
    paymentCancelled: "Payment cancelled — your message wasn't sent.",
    tipCancelledTitle: 'Tip cancelled',
    tipCancelledSubtitle: 'Your message was still sent.',
    errorEmailRequired: 'Use an email address: {name} replies to paid messages by email.',
    errorTipUnavailable: "Tips aren't available right now. Send your message without one.",
    errorPaymentUnavailable: "{name} can't take payments right now, so your message wasn't sent. Try again later.",
    errorCheckoutFailed: "The payment page didn't open, so your message wasn't sent. Try again.",
    chatPaid:
      '{name} charges for messages. Send yours from the message form: you pay there and get the reply by email.',
    chatPaidAction: 'Write a paid message',
  },
};

export const uaLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: 'Грає {index} з {count}',
    chapters: 'Розділи',
    transcript: 'Транскрипт',
    membersOnly: 'Лише для учасників',
    live: 'НАЖИВО',
    upcoming: 'Скоро',
    lessonOf: 'Урок {index} з {count}',
    days: 'днів',
    hours: 'год',
    minutes: 'хв',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: 'Усі',
    asked: 'Питання',
    answered: 'Відповідь',
    buy: 'Купити',
    resume: 'Продовжити',
    watched: 'Переглянуто {count} з {total}',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: 'Грає',
    mediaPlaceholder: 'Зображення або відео',
    badgeHint: 'Бейдж',
  },
  slider: {
    image: 'Зображення',
    before: 'До',
    after: 'Після',
  },
  wrongPage: {
    noItem: 'Такого елемента немає на цій сторінці',
    noBlock: 'Такого блока немає на цій сторінці',
    question: 'Перейти на сторінку з цим блоком?',
    goToPage: 'Перейти на сторінку',
  },
  common: {
    lauching: 'Завантаження',
    showMore: 'Показати більше',
    share: 'Поділітися',
  },
  bio: {
    expand: 'Дивитися більше',
  },
  timer: {
    days: 'Днів',
    hours: 'Годин',
    min: 'Хвилин',
    sec: 'Секунд',
  },
  form: {
    email: 'Email',
    name: "Ім'я",
    phone: 'Телефон',
    comment: "Коментар (необов'язково)",
    address: 'Адреса',
    insta: 'Інстаграм акаунт',
    submitEmail: 'Ми надіслали інформацію на вашу почту',
    total: 'Всього',
    firstName: "Ім'я",
    lastName: 'Фамілія',
    enterName: "Введіть ім'я та прізвище",
    enterEmail: 'Введіть email',
    enterAddress: 'Введіть адресу',
    enterComment: "Напишіть коментар (необов'язково)",
    thankYou: 'Спасибі!',
    error: 'Щось пішло не так 😥',
    successEmail: 'Вашу пошту успішно надіслано',
    successPhone: 'Ваш телефон успішно надіслано',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: 'Крок {current} з {total}',
    back: 'Назад',
    next: 'Далі',
    day: 'День',
    time: 'Час',
    chooseFile: 'Обрати файл',
    uploading: 'Завантаження…',
    uploaded: 'завантажено',
    uploadFailed: 'не вдалося завантажити',
    uploadTooLarge: 'завеликий',
    uploadLimit: 'до {size} МБ',
    removeFile: 'Прибрати',
    sending: 'Надсилаємо…',
    sentTitle: 'Повідомлення надіслано',
    sendAnother: 'Надіслати ще',
    closedTitle: 'Прийом відповідей закрито',
    closedText: '',
  },
  basket: {
    addItem: 'Додати в кошик',
    itemAdded: 'Товар доданий до кошика',
    orderNow: 'Замовити',
    goToCart: 'Перейти до кошика',
    continue: 'продовжити покупки',
    shoppingCart: 'Кошик',
    submitOrder: 'Підтвердити заказ',
    cancel: 'Скасувати',
    items: 'Товари',
    total: 'Всього',
    shipping: 'Доставка',
    shippingName: 'Введіть ПІБ',
    shippingEmail: 'Введіть email',
    shippingAddress: 'Введіть адресу',
    shippingComment: "Напишіть коментар (необов'язково)",
    paymentMethod: 'Оплата',
    stripe: 'Сплатити з Stripe',
    wayforpay: 'Сплатити карткою',
    cash: 'Готівка',
    buttonProcessOrder: 'Підтвердити замовлення',
    titleEmpty: 'Ваш кошик порожній',
    subtitleEmpty: 'Ви ще нічого не додали до кошика',
    bthShopNow: 'Перейти до магазину',
    successOrder: 'Ваше замовлення успішно оформлено!',
    errorOrder: 'Ваше замовлення не оформлене',
    bthHome: 'Перейти на Головну',
    quantity: 'К-сть',
  },
  contacts: {
    ask: 'Запитати у',
    orderWhatsApp: 'Замовити у WhatsApp',
  },
  features: {
    swipe: 'Свайп',
    more: 'Детальніше',
  },
  team: {
    getInTouch: 'Зв’язатися',
    profile: 'Профіль',
    people: 'людей',
    swipe: 'Свайп',
    otherPeople: 'Також тут',
  },
  donation: {
    textBuy: 'Купити',
    fieldComment: "Напишіть щось приємне...(необов'язково)",
    buttonSupport: 'Відправити',
  },
  category: {
    all: 'Всі',
    noItems: 'Немає товарів',
  },
  blog: {
    read: 'Читати',
    min: 'хв',
    minRead: 'хв читання',
    all: 'Всі',
    pinned: 'Закріплено',
    showMore: 'Показати більше',
  },
  faq: {
    noResults: 'Нічого не знайдено за цим запитом',
  },
  overview: {
    open: 'Відчинено',
    closed: 'Зачинено',
    closingSoon: 'Скоро зачиняється',
    openingSoon: 'Скоро відчиниться',
    open24: 'Відчинено 24 години',
    open24Detail: 'Щодня, цілодобово',
    byAppointment: 'За домовленістю',
    byAppointmentDetail: 'Забронюйте час візиту',
    temporarilyClosed: 'Тимчасово зачинено',
    permanentlyClosed: 'Зачинено назавжди',
    permanentlyClosedDetail: 'Заклад більше не працює',
    hoursUnknown: 'Години не вказані',
    hoursUnknownDetail: 'Зателефонуйте, щоб уточнити',

    closesAt: 'Зачиняється о {time}',
    closesInMinutes: 'Зачиняється через {minutes} хв',
    opensAt: 'Відчиняється о {time}',
    opensInMinutes: 'Відчиняється через {minutes} хв · {time}',
    opensTomorrow: 'Відчиняється завтра о {time}',
    // Nominative {day} would not decline after "у", so the day is set off with a colon instead.
    opensOnDay: 'Відчиняється: {day}, {time}',
    until: 'До',
    tomorrow: 'Завтра',

    directions: 'Маршрут',
    getDirections: 'Прокласти маршрут',
    call: 'Подзвонити',
    copyAddress: 'Копіювати адресу',
    otherLocation: 'Інша локація',
    busyHours: 'Завантаженість',
    popularEmpty: 'Завантаженість ще не додано',

    mon: 'Понеділок',
    tue: 'Вівторок',
    wed: 'Середа',
    thu: 'Четвер',
    fri: 'Пʼятниця',
    sat: 'Субота',
    sun: 'Неділя',
  },
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Запитайте будь-що...',
      continueChat: 'Продовжити чат',
      noResponse: 'Немає відповіді',
      sendError: 'Щось пішло не так. Спробуйте ще раз.',
      defaultBubbleTitle: 'AI-чат',
      launchLabel: 'Почати розмову',
      startChatLabel: 'Почати чат',
    },
  },
  link: {
    visitLink: 'Відкрити посилання',
  },
  map: {
    directions: 'Прокласти маршрут',
    copyAddress: 'Скопіювати адресу',
    call: 'Подзвонити',
    deliveryAddress: 'Введіть свою адресу',
    deliveryCheck: 'Перевірити відстань',
    searchPoint: 'Знайти найближчу точку',
  },
  gallery: {
    photos: 'фото',
    photo: 'фото',
    all: 'Усі',
    open: 'Відкрити',
    openGallery: 'Відкрити галерею',
  },
  pageList: {
    navigation: 'Навігація',
    previous: 'Попередня',
    next: 'Наступна',
    allPages: 'Усі сторінки розділу',
  },
  footer: {
    subscribe: 'Підписатися',
    subscribed: 'Дякуємо — ви у списку.',
    emailPlaceholder: 'you@email.com',
    app: 'Застосунок',
    payment: 'Оплата',
    language: 'Мова',
    currencyAndShipping: 'Валюта і доставка',
    messengers: 'Месенджери',
  },
  error: {
    correctEmail: 'Введіть правильний email',
    emptyField: 'Поле не може бути порожнім',
  },
  sort: {
    title: 'Сортування',
    search: 'Пошук',
    default: 'Сортування за замовчуванням',
    dateNew: 'Дата: від новішої до найстарішої',
    dateOld: 'Дата: від найдавніших до найновіших',
    priceLow: 'Ціна: від низької до високої',
    priceHigh: 'Ціна: від високої до низької',
    nameA: 'Назва: від А до Я',
    nameZ: 'Назва: від Я до А',
  },
  shop: {
    notify: 'Залишити заявку',
    itemsLeft: 'залишилось',
    notAvailable: 'Немає в наявності',
    available: 'Є у наявності',
    similar: 'Також рекомендуємо',
    similarEmpty: 'Немає схожих товарів',
    oldPriceLabel: 'Стара ціна',
    salePriceLabel: 'Акційна ціна',
    saleBadge: 'Акція',
  },
  file: {
    download: 'Завантажити',
    get: 'Отримати',
    current: 'Актуальна',
    files: 'файлів',
    gateTitle: 'Отримати файл',
    gateText: 'Залиште email — і завантаження відкриється тут же.',
    gateAction: 'Показати файл',
    gateNote: 'Ваш email отримає лише власник цієї сторінки.',
    largeFile: 'Великий файл — краще з Wi-Fi.',
    startDownload: 'Почати завантаження',
    kindDocument: 'Документи',
    kindImage: 'Зображення',
    kindVideo: 'Відео',
    kindAudio: 'Аудіо',
    kindArchive: 'Архіви',
    kindOther: 'Інші файли',
  },
  music: {
    play: 'Слухати',
    pause: 'Пауза',
    previous: 'Попередній',
    next: 'Наступний',
    listen: 'Слухати',
    listenOn: 'Слухати в',
    download: 'Завантажити',
    presave: 'Pre-save',
    buy: 'Купити',
    on: 'у',
    tracksCount: 'треків',
    tracklist: 'Трек-лист',
    upNext: 'Далі у черзі',
    newSingle: 'Новий сингл',
    addToBasket: 'Додати в кошик',
    preview: 'прев’ю',
    hoursShort: 'год',
    minutesShort: 'хв',
    emptyTracks: 'Ще немає треків',
    emptyReleases: 'Ще немає релізів',
    emptyReleaseLinks: 'Ще немає стрімінг-посилань',
    emptyPlaylists: 'Ще немає плейлистів',
  },
  podcast: {
    play: 'Слухати',
    pause: 'Пауза',
    playEpisode: 'Слухати епізод',
    playTrailer: 'Слухати трейлер',
    listen: 'Слухати',
    watch: 'Дивитися',
    latest: 'Свіже',
    guest: 'Гість',
    guests: 'Гості',
    moreGuests: 'Більше гостей',
    moreGuestsCaption: 'Увесь сезон',
    hostedBy: 'Ведуть',
    subscribe: 'Підписатися',
    episodes: 'епізодів',
    allEpisodes: 'Усі епізоди',
    addToQueue: 'Слухати все звідси',
    left: 'лишилось',
    mentioned: 'Згадано',
    transcript: 'Транскрипт',
    clip: 'Кліп',
    shareClip: 'Поділитися кліпом',
    share: 'Поділитися',
    speed: 'Швидкість',
    back15: 'Назад 15 секунд',
    forward30: 'Вперед 30 секунд',
    askTitle: 'Запитайте нас',
    sendQuestion: 'Надіслати питання',
    recordQuestion: 'Записати голосове питання',
    leaveReview: 'Залишити відгук',
    supportTitle: 'Підтримати шоу',
    becomeSupporter: 'Стати патроном',
    bestOfTitle: 'Уперше тут? Почніть із цих',
    bestOfText: 'Епізоди, якими діляться з друзями',
    emptyEpisodes: 'Ще немає епізодів',
    emptyShows: 'Ще немає шоу',
    emptyShowLinks: 'Додайте застосунки, де є це шоу',
    emptyChapters: 'Напишіть у нотатках епізоду рядки з таймкодами — і будуть розділи',
    emptyTranscript: 'Вставте транскрипт у нотатки епізоду у форматі «0:00 Ім’я: репліка»',
    emptyClip: 'Додайте нотатки — перше речення стане цитатою',
    emptyResume: 'Ще нічого не почато',
    emptyHosts: 'Вкажіть ведучого в епізоді, щоб заповнити картку',
    emptyGuests: 'Вкажіть гостя в епізоді, щоб заповнити картку',
    emptyTopics: 'Додайте шоу категорію, щоб фільтрувати за темами',
    emptyAsk: 'Додайте запит і адресу, куди йдуть відповіді',
    emptyRating: 'Додайте оцінку і відгук для цитати',
    emptySupport: 'Додайте рівні підтримки',
  },
  // The visitor's side of messaging: the "message me" modal, the floating button and the live
  // chat's audience checkbox. {name} is the page owner.
  messaging: {
    floatingButton: 'Написати мені',
    title: 'Повідомлення для {name}',
    subtitle: 'Напишіть {name} напряму.',
    faqTitle: 'Перш ніж питати',
    namePlaceholder: "Ваше ім'я (необов'язково)",
    contactPlaceholder: 'Email або номер телефону',
    messagePlaceholder: 'Повідомлення',
    consent: 'Додати мене до аудиторії {name}',
    signedInHint: '{name} отримає email вашого акаунта, щоб відповісти.',
    send: 'Надіслати',
    close: 'Закрити',
    sentTitle: 'Повідомлення надіслано',
    sentSubtitle: '{name} отримає ваше повідомлення.',
    errorGeneric: 'Повідомлення не надіслано. Перевірте з’єднання і спробуйте ще раз.',
    errorRateLimit: 'Ви надіслали кілька повідомлень за короткий час. Спробуйте за годину.',
    errorDisabled: '{name} зараз не приймає повідомлень.',
    errorTooLong: 'Задовго — скоротіть повідомлення і спробуйте ще раз.',
    errorContactRequired: 'Додайте email або телефон, щоб отримати відповідь від {name}.',
    errorEmpty: 'Спершу напишіть повідомлення.',
    // Платні повідомлення і чайові. {price} — сума з кодом валюти, напр. «5 USD».
    priceLine: '{price} · відповідь протягом {days}, інакше автоматичне повернення коштів',
    daysOne: '1 дня',
    daysOther: '{count} дн.',
    emailPlaceholder: 'Ваш email',
    emailRequiredHint: 'На платні повідомлення відповідають email-ом, тож вкажіть свою адресу.',
    sendPaid: 'Сплатити {price} і надіслати',
    tipTitle: 'Додати чайові (необов’язково)',
    tipNone: 'Без чайових',
    tipNotStarted: 'Оплату чайових не вдалося почати, але повідомлення надіслано.',
    paidSentTitle: 'Оплату отримано',
    paidSentSubtitle: '{name} відповість на email протягом {days}.',
    tipSentTitle: 'Дякуємо за чайові!',
    paymentCancelled: 'Оплату скасовано — повідомлення не надіслано.',
    tipCancelledTitle: 'Чайові скасовано',
    tipCancelledSubtitle: 'Ваше повідомлення все одно надіслано.',
    errorEmailRequired: 'Вкажіть email: {name} відповідає на платні повідомлення email-ом.',
    errorTipUnavailable: 'Чайові зараз недоступні. Надішліть повідомлення без них.',
    errorPaymentUnavailable: '{name} зараз не може прийняти оплату, тож повідомлення не надіслано. Спробуйте пізніше.',
    errorCheckoutFailed: 'Сторінка оплати не відкрилася, тож повідомлення не надіслано. Спробуйте ще раз.',
    chatPaid:
      '{name} бере плату за повідомлення. Напишіть через форму повідомлення: там ви сплатите й отримаєте відповідь на email.',
    chatPaidAction: 'Написати платне повідомлення',
  },
};

export const esLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: 'Reproduciendo {index} de {count}',
    chapters: 'Capítulos',
    transcript: 'Transcripción',
    membersOnly: 'Solo miembros',
    live: 'EN VIVO',
    upcoming: 'Próximamente',
    lessonOf: 'Lección {index} de {count}',
    days: 'días',
    hours: 'h',
    minutes: 'min',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: 'Todos',
    asked: 'Pregunta',
    answered: 'Respuesta',
    buy: 'Comprar',
    resume: 'Continuar',
    watched: '{count} de {total} vistos',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: 'En reproducción',
    mediaPlaceholder: 'Imagen o vídeo',
    badgeHint: 'Etiqueta',
  },
  slider: {
    image: 'Imagen',
    before: 'Antes',
    after: 'Después',
  },
  wrongPage: {
    noItem: 'Este elemento no existe en esta página',
    noBlock: 'Este bloque no existe en esta página',
    question: '¿Ir a la página con este bloque?',
    goToPage: 'Ir a la página',
  },
  common: {
    lauching: 'Lanzamiento',
    showMore: 'Mostrar más',
    share: 'Cuota',
  },
  bio: {
    expand: 'Ver más',
  },
  timer: {
    days: 'Dias',
    hours: 'Horas',
    min: 'Minutos',
    sec: 'Segundos',
  },
  form: {
    email: 'Correo electrónico',
    name: 'Nombre',
    phone: 'Teléfono',
    comment: 'Comentario (opcional)',
    address: 'Dirección',
    insta: 'Cuenta de Instagram',
    submitEmail: 'Enviamos información a su correo electrónico',
    total: 'Total',
    firstName: 'Nombre de pila',
    lastName: 'Apellido',
    enterName: 'Ingrese nombre y apellido',
    enterEmail: 'Ingrese correo electrónico',
    enterAddress: 'Dirección',
    enterComment: 'Сomentario (opcional)',
    thankYou: 'Gracias!',
    error: 'Algo salió mal',
    successEmail: 'Su correo electrónico ha sido enviado con éxito',
    successPhone: 'Su teléfono ha sido enviado con éxito',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: 'Paso {current} de {total}',
    back: 'Atrás',
    next: 'Siguiente',
    day: 'Día',
    time: 'Hora',
    chooseFile: 'Elegir un archivo',
    uploading: 'Subiendo…',
    uploaded: 'subido',
    uploadFailed: 'error al subir',
    uploadTooLarge: 'demasiado grande',
    uploadLimit: 'hasta {size} MB',
    removeFile: 'Quitar',
    sending: 'Enviando…',
    sentTitle: 'Mensaje enviado',
    sendAnother: 'Enviar otro',
    closedTitle: 'Los envíos están cerrados',
    closedText: '',
  },
  basket: {
    addItem: 'Añadir a la cesta',
    itemAdded: 'Artículo añadido a tu carrito',
    orderNow: 'Ordenar ahora',
    goToCart: 'Ir al carrito',
    continue: 'Seguir comprando',
    shoppingCart: 'Carro de la compra',
    submitOrder: 'Orden de envio',
    cancel: 'Cancelar',
    items: 'Productos',
    total: 'Total',
    shipping: 'Entrega',
    shippingName: 'Ingrese nombre y apellido',
    shippingEmail: 'Ingrese correo electrónico',
    shippingAddress: 'Ingresa la direccion',
    shippingComment: 'Introducir comentario (opcional)',
    paymentMethod: 'Método de pago',
    stripe: 'Pagar con Stripe',
    wayforpay: 'Tarjeta de débito o crédito',
    cash: 'Dinero en efectivo',
    buttonProcessOrder: 'Procesa tu pedido',
    titleEmpty: 'Tu carrito esta vacío',
    subtitleEmpty: 'Parece que aún no has añadido nada a tu carrito',
    bthShopNow: 'Compra ahora',
    successOrder: '¡Su pedido fue enviado con éxito!',
    errorOrder: 'Su pedido no fue enviado',
    bthHome: 'Ir a casa',
    quantity: 'ctd',
  },
  contacts: {
    ask: 'Pregunta en',
    orderWhatsApp: 'Orden en WhatsApp',
  },
  features: {
    swipe: 'Desliza',
    more: 'Saber más',
  },
  // Not translated yet — English until a translation lands (this file has no EN fallback).
  team: {
    getInTouch: 'Get in touch',
    profile: 'Profile',
    people: 'people',
    swipe: 'Swipe',
    otherPeople: 'Also here',
  },
  donation: {
    textBuy: 'Comprar',
    fieldComment: 'Di algo agradable... (opcional)',
    buttonSupport: 'Apoyo',
  },
  category: {
    all: 'Toda',
    noItems: 'No hay artículos',
  },
  // Not translated yet — English until a translation lands.
  blog: {
    read: 'Read',
    min: 'min',
    minRead: 'min read',
    all: 'All',
    pinned: 'Pinned',
    showMore: 'Show more',
  },
  // Not translated yet — English until a translation lands.
  faq: {
    noResults: 'Nothing matches that search',
  },
  // Not translated yet — English until a translation lands.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  // Not translated yet — English until a translation lands.
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Ask anything...',
      continueChat: 'Continue chat',
      noResponse: 'No response',
      sendError: 'Something went wrong. Please try again.',
      defaultBubbleTitle: 'AI Chat',
      launchLabel: 'Start the conversation',
      startChatLabel: 'Start a chat',
    },
  },
  link: {
    visitLink: 'Visitar enlace',
  },
  map: {
    directions: 'Cómo llegar',
    copyAddress: 'Copiar dirección',
    call: 'Llamar',
    deliveryAddress: 'Introduce tu dirección',
    deliveryCheck: 'Comprobar la distancia',
    searchPoint: 'Encuentra el punto más cercano',
  },
  // Not translated yet — English until a translation lands.
  gallery: {
    photos: 'photos',
    photo: 'photo',
    all: 'All',
    open: 'Open',
    openGallery: 'Open the gallery',
  },
  pageList: {
    navigation: 'Navegación',
    previous: 'Anterior',
    next: 'Siguiente',
    // Not translated yet — English until a translation lands.
    allPages: 'All pages of this section',
  },
  footer: {
    subscribe: 'Suscribirse',
    subscribed: 'Gracias: ya estás en la lista.',
    emailPlaceholder: 'you@email.com',
    app: 'App',
    payment: 'Pago',
    language: 'Idioma',
    currencyAndShipping: 'Moneda y envío',
    messengers: 'Mensajería',
  },
  error: {
    correctEmail: 'Ingrese el correo electrónico correcto',
    emptyField: 'El campo no puede estar vacío',
  },
  sort: {
    title: 'Clasificación',
    search: 'Búsqueda',
    default: 'Orden predeterminado',
    dateNew: 'Fecha: del más nuevo al más antiguo',
    dateOld: 'Fecha: del más antiguo al más reciente',
    priceLow: 'Precios de barato a caro',
    priceHigh: 'Precio: de mayor a menor',
    nameA: 'Nombre: de la A a la Z',
    nameZ: 'Nombre: de la Z a la A',
  },
  shop: {
    notify: 'Notificarme',
    itemsLeft: 'quedan  artículos',
    notAvailable: 'No disponible',
    available: 'Disponible',
    similar: 'También recomendamos',
    similarEmpty: 'No se encontraron productos similares',
  },
  file: {
    download: 'Descargar',
    get: 'Obtener',
    current: 'Actual',
    files: 'archivos',
    gateTitle: 'Consigue el archivo',
    gateText: 'Deja tu correo y la descarga se abrirá aquí mismo.',
    gateAction: 'Mostrar el archivo',
    gateNote: 'Tu correo solo lo recibe el dueño de esta página.',
    largeFile: 'Descarga grande: mejor con Wi-Fi.',
    startDownload: 'Iniciar descarga',
    kindDocument: 'Documentos',
    kindImage: 'Imágenes',
    kindVideo: 'Vídeo',
    kindAudio: 'Audio',
    kindArchive: 'Archivos comprimidos',
    kindOther: 'Otros archivos',
  },
  music: {
    play: 'Reproducir',
    pause: 'Pausa',
    previous: 'Anterior',
    next: 'Siguiente',
    listen: 'Escuchar',
    listenOn: 'Escuchar en',
    download: 'Descargar',
    presave: 'Pre-guardar',
    buy: 'Comprar',
    on: 'en',
    tracksCount: 'pistas',
    tracklist: 'Lista de pistas',
    upNext: 'A continuación',
    newSingle: 'Nuevo single',
    addToBasket: 'Añadir al carrito',
    preview: 'vista previa',
    hoursShort: 'h',
    minutesShort: 'min',
    emptyTracks: 'Aún no hay pistas',
    emptyReleases: 'Aún no hay lanzamientos',
    emptyReleaseLinks: 'Aún no hay enlaces de streaming',
    emptyPlaylists: 'Aún no hay listas',
  },
  podcast: {
    play: 'Reproducir',
    pause: 'Pausa',
    playEpisode: 'Reproducir episodio',
    playTrailer: 'Reproducir tráiler',
    listen: 'Escuchar',
    watch: 'Ver',
    latest: 'Reciente',
    guest: 'Invitado',
    guests: 'Invitados',
    moreGuests: 'Más invitados',
    moreGuestsCaption: 'Ver la temporada completa',
    hostedBy: 'Presentado por',
    subscribe: 'Suscribirse',
    episodes: 'episodios',
    allEpisodes: 'Todos los episodios',
    addToQueue: 'Reproducir todo desde aquí',
    left: 'restantes',
    mentioned: 'Mencionado',
    transcript: 'Transcripción',
    clip: 'Clip',
    shareClip: 'Compartir este clip',
    share: 'Compartir',
    speed: 'Velocidad',
    back15: 'Atrás 15 segundos',
    forward30: 'Adelante 30 segundos',
    askTitle: 'Pregúntanos lo que sea',
    sendQuestion: 'Enviar pregunta',
    recordQuestion: 'Grabar una pregunta de voz',
    leaveReview: 'Dejar una reseña',
    supportTitle: 'Apoya el programa',
    becomeSupporter: 'Hazte mecenas',
    bestOfTitle: '¿Nuevo aquí? Empieza por estos',
    bestOfText: 'Episodios que la gente comparte',
    emptyEpisodes: 'Aún no hay episodios',
    emptyShows: 'Aún no hay programas',
    emptyShowLinks: 'Añade las apps donde está este programa',
    emptyChapters: 'Escribe líneas con marcas de tiempo en las notas para tener capítulos',
    emptyTranscript: 'Pega una transcripción en las notas como «0:00 Nombre: línea»',
    emptyClip: 'Añade notas — la primera frase será la cita',
    emptyResume: 'Nada empezado aún',
    emptyHosts: 'Nombra al presentador en un episodio para llenar esta tarjeta',
    emptyGuests: 'Nombra a un invitado en un episodio para llenar esta tarjeta',
    emptyTopics: 'Da una categoría a los programas para filtrar por tema',
    emptyAsk: 'Añade la pregunta y adónde van las respuestas',
    emptyRating: 'Añade tu puntuación y una reseña para citar',
    emptySupport: 'Añade tus niveles de apoyo',
  },
};

export const ptLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: 'Reproduzindo {index} de {count}',
    chapters: 'Capítulos',
    transcript: 'Transcrição',
    membersOnly: 'Apenas membros',
    live: 'AO VIVO',
    upcoming: 'Em breve',
    lessonOf: 'Aula {index} de {count}',
    days: 'dias',
    hours: 'h',
    minutes: 'min',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: 'Todos',
    asked: 'Pergunta',
    answered: 'Resposta',
    buy: 'Comprar',
    resume: 'Continuar',
    watched: '{count} de {total} vistos',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: 'Reproduzindo',
    mediaPlaceholder: 'Imagem ou vídeo',
    badgeHint: 'Etiqueta',
  },
  slider: {
    image: 'Imagem',
    before: 'Antes',
    after: 'Depois',
  },
  wrongPage: {
    noItem: 'Este item não existe nesta página',
    noBlock: 'Este bloco não existe nesta página',
    question: 'Ir para a página com este bloco?',
    goToPage: 'Ir para a página',
  },
  common: {
    lauching: 'Lançamento',
    showMore: 'Mostre mais',
    share: 'Compartilhar',
  },
  bio: {
    expand: 'Ver mais',
  },
  timer: {
    days: 'Dias',
    hours: 'Horas',
    min: 'Minutos',
    sec: 'Segundos',
  },
  form: {
    email: 'O email',
    name: 'Nome',
    phone: 'Telefone',
    comment: 'Comente (opcional)',
    address: 'Endereço',
    insta: 'Conta do Instagram',
    submitEmail: 'Enviamos informações para o seu e-mail',
    total: 'Total',
    firstName: 'Primeiro nome',
    lastName: 'Sobrenome',
    enterName: 'Insira o nome e o sobrenome',
    enterEmail: 'Digite o e-mail',
    enterAddress: 'Insira o endereço',
    enterComment: 'СComente (opcional)',
    thankYou: 'Obrigado!',
    error: 'Algo deu errado',
    successEmail: 'Seu e-mail foi enviado com sucesso',
    successPhone: 'Seu telefone foi enviado com sucesso',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: 'Etapa {current} de {total}',
    back: 'Voltar',
    next: 'Avançar',
    day: 'Dia',
    time: 'Hora',
    chooseFile: 'Escolher um arquivo',
    uploading: 'Enviando…',
    uploaded: 'enviado',
    uploadFailed: 'falha no envio',
    uploadTooLarge: 'muito grande',
    uploadLimit: 'até {size} MB',
    removeFile: 'Remover',
    sending: 'Enviando…',
    sentTitle: 'Mensagem enviada',
    sendAnother: 'Enviar outra',
    closedTitle: 'Os envios estão encerrados',
    closedText: '',
  },
  basket: {
    addItem: 'Adicionar ao carrinho',
    itemAdded: 'Item adicionado ao seu carrinho',
    orderNow: 'Peça agora',
    goToCart: 'Vá para o carrinho',
    continue: 'Continue comprando',
    shoppingCart: 'Carrinho de compras',
    submitOrder: 'Enviar pedido',
    cancel: 'Cancelar',
    items: 'Produtos',
    total: 'Total',
    shipping: 'Entrega',
    shippingName: 'Digite o nome e sobrenome',
    shippingEmail: 'Digite o e-mail',
    shippingAddress: 'Insira o endereço',
    shippingComment: 'Escreva um comentário (opcional)',
    paymentMethod: 'Forma de pagamento',
    stripe: 'Pagamento com Stripe',
    wayforpay: 'Cartão de débito ou crédito',
    cash: 'Dinheiro',
    buttonProcessOrder: 'Processe seu pedido',
    titleEmpty: 'Sua cesta está vazia',
    subtitleEmpty: 'Parece que você ainda não adicionou nada ao seu carrinho',
    bthShopNow: 'Compre agora',
    successOrder: 'Seu pedido foi enviado com sucesso!',
    errorOrder: 'Seu pedido não foi enviado',
    bthHome: 'Para a página inicial',
    quantity: 'quant',
  },
  contacts: {
    ask: 'Pergunte no',
    orderWhatsApp: 'Pedido no WhatsApp',
  },
  features: {
    swipe: 'Arraste',
    more: 'Saber mais',
  },
  // Not translated yet — English until a translation lands (this file has no EN fallback).
  team: {
    getInTouch: 'Get in touch',
    profile: 'Profile',
    people: 'people',
    swipe: 'Swipe',
    otherPeople: 'Also here',
  },
  donation: {
    textBuy: 'Comprar',
    fieldComment: 'Diga algo legal... (opcional)',
    buttonSupport: 'Apoio, suporte',
  },
  category: {
    all: 'Tudo',
    noItems: 'Nenhum item',
  },
  // Not translated yet — English until a translation lands.
  blog: {
    read: 'Read',
    min: 'min',
    minRead: 'min read',
    all: 'All',
    pinned: 'Pinned',
    showMore: 'Show more',
  },
  // Not translated yet — English until a translation lands.
  faq: {
    noResults: 'Nothing matches that search',
  },
  // Not translated yet — English until a translation lands.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  // Not translated yet — English until a translation lands.
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Ask anything...',
      continueChat: 'Continue chat',
      noResponse: 'No response',
      sendError: 'Something went wrong. Please try again.',
      defaultBubbleTitle: 'AI Chat',
      launchLabel: 'Start the conversation',
      startChatLabel: 'Start a chat',
    },
  },
  link: {
    visitLink: 'Acesse o link',
  },
  map: {
    directions: 'Como chegar',
    copyAddress: 'Copiar endereço',
    call: 'Ligar',
    deliveryAddress: 'Digite seu endereço',
    deliveryCheck: 'Verificar a distância',
    searchPoint: 'Encontre o ponto mais próximo',
  },
  // Not translated yet — English until a translation lands.
  gallery: {
    photos: 'photos',
    photo: 'photo',
    all: 'All',
    open: 'Open',
    openGallery: 'Open the gallery',
  },
  pageList: {
    navigation: 'Navegação',
    previous: 'Anterior',
    next: 'Seguinte',
    // Not translated yet — English until a translation lands.
    allPages: 'All pages of this section',
  },
  footer: {
    subscribe: 'Subscrever',
    subscribed: 'Obrigado — já está na lista.',
    emailPlaceholder: 'you@email.com',
    app: 'App',
    payment: 'Pagamento',
    language: 'Idioma',
    currencyAndShipping: 'Moeda e envio',
    messengers: 'Mensageiros',
  },
  error: {
    correctEmail: 'Digite o e-mail correto',
    emptyField: 'O campo não pode ficar vazio',
  },
  sort: {
    title: 'Ordenação',
    search: 'Procurar',
    default: 'Classificação padrão',
    dateNew: 'Data: do mais recente ao mais antigo',
    dateOld: 'Data: Do mais antigo para o mais recente',
    priceLow: 'Preço: Baixo a Alto',
    priceHigh: 'Preço: Alto a Baixo',
    nameA: 'Nome: A a Z',
    nameZ: 'Nome: Z a A',
  },
  shop: {
    notify: 'Me avise',
    itemsLeft: 'itens restantes',
    notAvailable: 'Não disponível',
    available: 'Acessível',
    similar: 'Também recomendado',
    similarEmpty: 'Produtos similares não encontrados',
  },
  file: {
    download: 'Baixar',
    get: 'Obter',
    current: 'Atual',
    files: 'arquivos',
    gateTitle: 'Receba o arquivo',
    gateText: 'Deixe seu e-mail e o download abre aqui mesmo.',
    gateAction: 'Mostrar o arquivo',
    gateNote: 'Seu e-mail vai apenas para o dono desta página.',
    largeFile: 'Download grande — melhor no Wi-Fi.',
    startDownload: 'Iniciar download',
    kindDocument: 'Documentos',
    kindImage: 'Imagens',
    kindVideo: 'Vídeo',
    kindAudio: 'Áudio',
    kindArchive: 'Arquivos compactados',
    kindOther: 'Outros arquivos',
  },
  music: {
    play: 'Tocar',
    pause: 'Pausar',
    previous: 'Anterior',
    next: 'Próxima',
    listen: 'Ouvir',
    listenOn: 'Ouvir no',
    download: 'Baixar',
    presave: 'Pré-save',
    buy: 'Comprar',
    on: 'no',
    tracksCount: 'faixas',
    tracklist: 'Lista de faixas',
    upNext: 'A seguir',
    newSingle: 'Novo single',
    addToBasket: 'Adicionar ao carrinho',
    preview: 'prévia',
    hoursShort: 'h',
    minutesShort: 'min',
    emptyTracks: 'Ainda sem faixas',
    emptyReleases: 'Ainda sem lançamentos',
    emptyReleaseLinks: 'Ainda sem links de streaming',
    emptyPlaylists: 'Ainda sem playlists',
  },
  podcast: {
    play: 'Tocar',
    pause: 'Pausar',
    playEpisode: 'Tocar episódio',
    playTrailer: 'Tocar trailer',
    listen: 'Ouvir',
    watch: 'Assistir',
    latest: 'Recente',
    guest: 'Convidado',
    guests: 'Convidados',
    moreGuests: 'Mais convidados',
    moreGuestsCaption: 'Ver a temporada completa',
    hostedBy: 'Apresentado por',
    subscribe: 'Assinar',
    episodes: 'episódios',
    allEpisodes: 'Todos os episódios',
    addToQueue: 'Tocar tudo a partir daqui',
    left: 'restantes',
    mentioned: 'Mencionado',
    transcript: 'Transcrição',
    clip: 'Clipe',
    shareClip: 'Compartilhar este clipe',
    share: 'Compartilhar',
    speed: 'Velocidade',
    back15: 'Voltar 15 segundos',
    forward30: 'Avançar 30 segundos',
    askTitle: 'Pergunte o que quiser',
    sendQuestion: 'Enviar pergunta',
    recordQuestion: 'Gravar uma pergunta em áudio',
    leaveReview: 'Deixar uma avaliação',
    supportTitle: 'Apoie o programa',
    becomeSupporter: 'Tornar-se apoiador',
    bestOfTitle: 'Novo por aqui? Comece por estes',
    bestOfText: 'Episódios que as pessoas compartilham',
    emptyEpisodes: 'Ainda sem episódios',
    emptyShows: 'Ainda sem programas',
    emptyShowLinks: 'Adicione os apps onde este programa está',
    emptyChapters: 'Escreva linhas com marcações de tempo nas notas para ter capítulos',
    emptyTranscript: 'Cole a transcrição nas notas como "0:00 Nome: fala"',
    emptyClip: 'Adicione notas — a primeira frase vira a citação',
    emptyResume: 'Nada começado ainda',
    emptyHosts: 'Nomeie o apresentador em um episódio para preencher este cartão',
    emptyGuests: 'Nomeie um convidado em um episódio para preencher este cartão',
    emptyTopics: 'Dê uma categoria aos programas para filtrar por tema',
    emptyAsk: 'Adicione a pergunta e para onde vão as respostas',
    emptyRating: 'Adicione sua nota e uma avaliação para citar',
    emptySupport: 'Adicione seus níveis de apoio',
  },
};

export const frLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: 'Lecture {index} sur {count}',
    chapters: 'Chapitres',
    transcript: 'Transcription',
    membersOnly: 'Réservé aux membres',
    live: 'EN DIRECT',
    upcoming: 'À venir',
    lessonOf: 'Leçon {index} sur {count}',
    days: 'jours',
    hours: 'h',
    minutes: 'min',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: 'Tout',
    asked: 'Question',
    answered: 'Réponse',
    buy: 'Acheter',
    resume: 'Reprendre',
    watched: '{count} sur {total} vus',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: 'En lecture',
    mediaPlaceholder: 'Image ou vidéo',
    badgeHint: 'Badge',
  },
  slider: {
    image: 'Image',
    before: 'Avant',
    after: 'Après',
  },
  wrongPage: {
    noItem: "Cet élément n'existe pas sur cette page",
    noBlock: "Ce bloc n'existe pas sur cette page",
    question: 'Aller à la page avec ce bloc ?',
    goToPage: 'Aller à la page',
  },
  common: {
    lauching: 'Lançamento',
    showMore: 'Montre plus',
    share: 'Partager',
  },
  bio: {
    expand: 'Voir plus',
  },
  timer: {
    days: 'Jours',
    hours: 'Les heures',
    min: 'Minutes',
    sec: 'Secondes',
  },
  form: {
    email: 'E-mail',
    name: 'Nom',
    phone: 'Téléphone',
    comment: 'Commenter (facultatif)',
    address: 'Adresse',
    insta: 'Compte Instagram',
    submitEmail: 'Nous avons envoyé des informations à votre e-mail',
    total: 'Total',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    enterName: 'Entrez le prénom et le nom',
    enterEmail: "Entrez l'email",
    enterAddress: "Entrer l'adresse",
    enterComment: 'Entrez un commentaire (facultatif)',
    thankYou: 'Merci!',
    error: 'Un problème est survenu',
    successEmail: 'Votre e-mail a été soumis avec succès',
    successPhone: 'Votre téléphone a été soumis avec succès',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: 'Étape {current} sur {total}',
    back: 'Retour',
    next: 'Suivant',
    day: 'Jour',
    time: 'Heure',
    chooseFile: 'Choisir un fichier',
    uploading: 'Envoi…',
    uploaded: 'envoyé',
    uploadFailed: "échec de l'envoi",
    uploadTooLarge: 'trop volumineux',
    uploadLimit: "jusqu'à {size} Mo",
    removeFile: 'Retirer',
    sending: 'Envoi…',
    sentTitle: 'Message envoyé',
    sendAnother: 'Envoyer un autre',
    closedTitle: 'Les envois sont clos',
    closedText: '',
  },
  basket: {
    addItem: 'Ajouter au panier',
    itemAdded: 'Article ajouté à votre panier',
    orderNow: 'Commandez maintenant',
    goToCart: 'Aller au panier',
    continue: 'Continuer vos achats',
    shoppingCart: 'Panier',
    submitOrder: 'Soumettre la commande',
    cancel: 'Annuler',
    items: 'Des produits',
    total: 'Le total',
    shipping: 'Livraison',
    shippingName: 'Entrez le prénom et le nom',
    shippingEmail: "Entrez l'e-mail",
    shippingAddress: "Entrer l'adresse",
    shippingComment: 'Écrivez un commentaire (facultatif)',
    paymentMethod: 'Mode de paiement',
    stripe: 'Paiement avec Stripe',
    wayforpay: 'Сarte de crédit',
    cash: 'En espèces',
    buttonProcessOrder: 'Confirmer la commande',
    titleEmpty: 'Votre panier est vide',
    subtitleEmpty: "Vous n'avez encore rien ajouté à votre panier",
    bthShopNow: 'Aller au magasin',
    successOrder: 'Votre commande a été passée avec succès !',
    errorOrder: "Votre commande n'a pas été passée",
    bthHome: 'Retour',
    quantity: 'quant',
  },
  contacts: {
    ask: 'Demandez sur',
    orderWhatsApp: 'Commandez sur WhatsApp',
  },
  features: {
    swipe: 'Faites glisser',
    more: 'En savoir plus',
  },
  // Not translated yet — English until a translation lands (this file has no EN fallback).
  team: {
    getInTouch: 'Get in touch',
    profile: 'Profile',
    people: 'people',
    swipe: 'Swipe',
    otherPeople: 'Also here',
  },
  donation: {
    textBuy: 'Acheter',
    fieldComment: 'Écrivez un commentaire.. (facultatif)',
    buttonSupport: 'Soutien',
  },
  category: {
    all: 'Tout',
    noItems: "Pas d'objet",
  },
  // Not translated yet — English until a translation lands.
  blog: {
    read: 'Read',
    min: 'min',
    minRead: 'min read',
    all: 'All',
    pinned: 'Pinned',
    showMore: 'Show more',
  },
  // Not translated yet — English until a translation lands.
  faq: {
    noResults: 'Nothing matches that search',
  },
  // Not translated yet — English until a translation lands.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  // Not translated yet — English until a translation lands.
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Ask anything...',
      continueChat: 'Continue chat',
      noResponse: 'No response',
      sendError: 'Something went wrong. Please try again.',
      defaultBubbleTitle: 'AI Chat',
      launchLabel: 'Start the conversation',
      startChatLabel: 'Start a chat',
    },
  },
  link: {
    visitLink: 'Suivez le lien',
  },
  map: {
    directions: 'Itinéraire',
    copyAddress: 'Copier l’adresse',
    call: 'Appeler',
    deliveryAddress: 'Saisissez votre adresse',
    deliveryCheck: 'Vérifier la distance',
    searchPoint: 'Trouver le point le plus proche',
  },
  // Not translated yet — English until a translation lands.
  gallery: {
    photos: 'photos',
    photo: 'photo',
    all: 'All',
    open: 'Open',
    openGallery: 'Open the gallery',
  },
  pageList: {
    navigation: 'Navigation',
    previous: 'Précédente',
    next: 'Suivante',
    // Not translated yet — English until a translation lands.
    allPages: 'All pages of this section',
  },
  footer: {
    subscribe: 'S’abonner',
    subscribed: 'Merci — vous êtes inscrit.',
    emailPlaceholder: 'you@email.com',
    app: 'App',
    payment: 'Paiement',
    language: 'Langue',
    currencyAndShipping: 'Devise et livraison',
    messengers: 'Messageries',
  },
  error: {
    correctEmail: "Saisissez l'adresse e-mail correcte",
    emptyField: 'Le champ ne peut pas être vide',
  },
  sort: {
    title: 'Tri',
    search: 'Chercher',
    default: 'Tri par défaut',
    dateNew: 'Date : du plus récent au plus ancien',
    dateOld: 'Date : du plus ancien au plus récent',
    priceLow: 'Prix   croissant',
    priceHigh: 'Prix : du plus élevé au plus bas',
    nameA: 'Nom : A à Z',
    nameZ: 'Nom : Z à A',
  },
  shop: {
    notify: 'Prévenez-moi',
    itemsLeft: 'articles restants',
    notAvailable: 'Indisponible',
    available: 'Disponible',
    similar: 'Également recommandé',
    similarEmpty: 'Produits similaires introuvables',
  },
  file: {
    download: 'Télécharger',
    get: 'Obtenir',
    current: 'Actuelle',
    files: 'fichiers',
    gateTitle: 'Obtenir le fichier',
    gateText: "Laissez votre e-mail et le téléchargement s'ouvre ici.",
    gateAction: 'Afficher le fichier',
    gateNote: 'Votre e-mail va uniquement au propriétaire de cette page.',
    largeFile: 'Téléchargement volumineux — Wi-Fi recommandé.',
    startDownload: 'Démarrer le téléchargement',
    kindDocument: 'Documents',
    kindImage: 'Images',
    kindVideo: 'Vidéo',
    kindAudio: 'Audio',
    kindArchive: 'Archives',
    kindOther: 'Autres fichiers',
  },
  music: {
    play: 'Écouter',
    pause: 'Pause',
    previous: 'Précédent',
    next: 'Suivant',
    listen: 'Écouter',
    listenOn: 'Écouter sur',
    download: 'Télécharger',
    presave: 'Pré-enregistrer',
    buy: 'Acheter',
    on: 'sur',
    tracksCount: 'titres',
    tracklist: 'Liste des titres',
    upNext: 'À suivre',
    newSingle: 'Nouveau single',
    addToBasket: 'Ajouter au panier',
    preview: 'extrait',
    hoursShort: 'h',
    minutesShort: 'min',
    emptyTracks: 'Aucun titre pour l’instant',
    emptyReleases: 'Aucune sortie pour l’instant',
    emptyReleaseLinks: 'Aucun lien de streaming pour l’instant',
    emptyPlaylists: 'Aucune playlist pour l’instant',
  },
  podcast: {
    play: 'Écouter',
    pause: 'Pause',
    playEpisode: 'Écouter l’épisode',
    playTrailer: 'Écouter la bande-annonce',
    listen: 'Écouter',
    watch: 'Regarder',
    latest: 'Récent',
    guest: 'Invité',
    guests: 'Invités',
    moreGuests: 'Plus d’invités',
    moreGuestsCaption: 'Voir toute la saison',
    hostedBy: 'Présenté par',
    subscribe: 'S’abonner',
    episodes: 'épisodes',
    allEpisodes: 'Tous les épisodes',
    addToQueue: 'Tout écouter à partir d’ici',
    left: 'restantes',
    mentioned: 'Mentionné',
    transcript: 'Transcription',
    clip: 'Extrait',
    shareClip: 'Partager cet extrait',
    share: 'Partager',
    speed: 'Vitesse',
    back15: 'Reculer de 15 secondes',
    forward30: 'Avancer de 30 secondes',
    askTitle: 'Posez-nous vos questions',
    sendQuestion: 'Envoyer la question',
    recordQuestion: 'Enregistrer une question vocale',
    leaveReview: 'Laisser un avis',
    supportTitle: 'Soutenir l’émission',
    becomeSupporter: 'Devenir soutien',
    bestOfTitle: 'Nouveau ici ? Commencez par ceux-ci',
    bestOfText: 'Les épisodes que l’on partage',
    emptyEpisodes: 'Aucun épisode pour l’instant',
    emptyShows: 'Aucune émission pour l’instant',
    emptyShowLinks: 'Ajoutez les applis où se trouve l’émission',
    emptyChapters: 'Écrivez des lignes horodatées dans les notes pour obtenir des chapitres',
    emptyTranscript: 'Collez une transcription dans les notes au format « 0:00 Nom : ligne »',
    emptyClip: 'Ajoutez des notes — la première phrase devient la citation',
    emptyResume: 'Rien de commencé pour l’instant',
    emptyHosts: 'Nommez l’animateur dans un épisode pour remplir cette carte',
    emptyGuests: 'Nommez un invité dans un épisode pour remplir cette carte',
    emptyTopics: 'Donnez une catégorie aux émissions pour filtrer par thème',
    emptyAsk: 'Ajoutez la question et où vont les réponses',
    emptyRating: 'Ajoutez votre note et un avis à citer',
    emptySupport: 'Ajoutez vos paliers de soutien',
  },
};

export const deLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: 'Wiedergabe {index} von {count}',
    chapters: 'Kapitel',
    transcript: 'Transkript',
    membersOnly: 'Nur für Mitglieder',
    live: 'LIVE',
    upcoming: 'Demnächst',
    lessonOf: 'Lektion {index} von {count}',
    days: 'Tage',
    hours: 'Std.',
    minutes: 'Min.',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: 'Alle',
    asked: 'Frage',
    answered: 'Antwort',
    buy: 'Kaufen',
    resume: 'Fortsetzen',
    watched: '{count} von {total} gesehen',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: 'Läuft',
    mediaPlaceholder: 'Bild oder Video',
    badgeHint: 'Badge',
  },
  slider: {
    image: 'Bild',
    before: 'Vorher',
    after: 'Nachher',
  },
  wrongPage: {
    noItem: 'Dieses Element gibt es auf dieser Seite nicht',
    noBlock: 'Dieser Block gibt es auf dieser Seite nicht',
    question: 'Zur Seite mit diesem Block gehen?',
    goToPage: 'Zur Seite gehen',
  },
  common: {
    lauching: 'Starten',
    showMore: 'Zeig mehr',
    share: 'Teilen',
  },
  bio: {
    expand: 'Mehr sehen',
  },
  timer: {
    days: 'Tage',
    hours: 'Std',
    min: 'Protokoll',
    sec: 'Sekunden',
  },
  form: {
    email: 'Email',
    name: 'Name',
    phone: 'Telefon',
    comment: 'Kommentar (optional)',
    address: 'Adresse',
    insta: 'Instagram-Account',
    submitEmail: 'Wir haben Informationen an Ihre E-Mail gesendet',
    total: 'Gesamt',
    firstName: 'Vorname',
    lastName: 'Nachname',
    enterName: 'Geben Sie den Vor- und Nachnamen ein',
    enterEmail: 'Email eingeben',
    enterAddress: 'Adresse eingeben',
    enterComment: 'Kommentar eingeben (optional)',
    thankYou: 'Danke!',
    error: 'Etwas ist schief gelaufen',
    successEmail: 'Ihre E-Mail wurde erfolgreich übermittelt',
    successPhone: 'Ihr Telefon wurde erfolgreich übermittelt',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: 'Schritt {current} von {total}',
    back: 'Zurück',
    next: 'Weiter',
    day: 'Tag',
    time: 'Uhrzeit',
    chooseFile: 'Datei auswählen',
    uploading: 'Wird hochgeladen…',
    uploaded: 'hochgeladen',
    uploadFailed: 'Upload fehlgeschlagen',
    uploadTooLarge: 'zu groß',
    uploadLimit: 'bis zu {size} MB',
    removeFile: 'Entfernen',
    sending: 'Wird gesendet…',
    sentTitle: 'Nachricht gesendet',
    sendAnother: 'Weitere senden',
    closedTitle: 'Einsendungen sind geschlossen',
    closedText: '',
  },
  basket: {
    addItem: 'In den Warenkorb legen',
    itemAdded: 'Artikel in den Warenkorb gelegt',
    orderNow: 'Jetzt bestellen',
    goToCart: 'Gehe zum Wagen',
    continue: 'Mit dem Einkaufen fortfahren',
    shoppingCart: 'Einkaufswagen',
    submitOrder: 'Bestellung abschicken',
    cancel: 'Stornieren',
    items: 'Produkte',
    total: 'Gesamt',
    shipping: 'Die Zustellung',
    shippingName: 'Geben Sie den Vor- und Nachnamen ein',
    shippingEmail: 'Email eingeben',
    shippingAddress: 'Adresse eingeben',
    shippingComment: 'Kommentar schreiben (optional)',
    paymentMethod: 'Zahlungsmethode',
    stripe: 'Zahlung mit Stripe',
    wayforpay: 'Kredit- oder Debitkarte',
    cash: 'Kasse',
    buttonProcessOrder: 'Bestätige die Bestellung',
    titleEmpty: 'Dein Korb ist leer',
    subtitleEmpty: 'Sie haben Ihrem Warenkorb noch nichts hinzugefügt',
    bthShopNow: 'Zum Laden gehen',
    successOrder: 'Ihre Bestellung wurde erfolgreich aufgegeben!',
    errorOrder: 'Ihre Bestellung wurde nicht aufgegeben',
    bthHome: 'Zurück',
    quantity: 'Anz',
  },
  contacts: {
    ask: 'Fragen Sie in',
    orderWhatsApp: 'Bestellen Sie auf WhatsApp',
  },
  features: {
    swipe: 'Wischen',
    more: 'Mehr erfahren',
  },
  // Not translated yet — English until a translation lands (this file has no EN fallback).
  team: {
    getInTouch: 'Get in touch',
    profile: 'Profile',
    people: 'people',
    swipe: 'Swipe',
    otherPeople: 'Also here',
  },
  donation: {
    textBuy: 'Kaufen',
    fieldComment: 'Schreiben Sie einen Kommentar.. (optional)',
    buttonSupport: 'Unterstützung',
  },
  category: {
    all: 'Alles',
    noItems: 'Nichts gefunden',
  },
  // Not translated yet — English until a translation lands.
  blog: {
    read: 'Read',
    min: 'min',
    minRead: 'min read',
    all: 'All',
    pinned: 'Pinned',
    showMore: 'Show more',
  },
  // Not translated yet — English until a translation lands.
  faq: {
    noResults: 'Nothing matches that search',
  },
  // Not translated yet — English until a translation lands.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  // Not translated yet — English until a translation lands.
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Ask anything...',
      continueChat: 'Continue chat',
      noResponse: 'No response',
      sendError: 'Something went wrong. Please try again.',
      defaultBubbleTitle: 'AI Chat',
      launchLabel: 'Start the conversation',
      startChatLabel: 'Start a chat',
    },
  },
  link: {
    visitLink: 'Folge dem Link',
  },
  map: {
    directions: 'Route planen',
    copyAddress: 'Adresse kopieren',
    call: 'Anrufen',
    deliveryAddress: 'Adresse eingeben',
    deliveryCheck: 'Entfernung prüfen',
    searchPoint: 'Nächsten Standort finden',
  },
  // Not translated yet — English until a translation lands.
  gallery: {
    photos: 'photos',
    photo: 'photo',
    all: 'All',
    open: 'Open',
    openGallery: 'Open the gallery',
  },
  pageList: {
    navigation: 'Navigation',
    previous: 'Zurück',
    next: 'Weiter',
    // Not translated yet — English until a translation lands.
    allPages: 'All pages of this section',
  },
  footer: {
    subscribe: 'Abonnieren',
    subscribed: 'Danke — Sie sind dabei.',
    emailPlaceholder: 'you@email.com',
    app: 'App',
    payment: 'Zahlung',
    language: 'Sprache',
    currencyAndShipping: 'Währung und Versand',
    messengers: 'Messenger',
  },
  error: {
    correctEmail: 'Geben Sie die richtige E-Mail-Adresse ein',
    emptyField: 'Feld darf nicht leer sein',
  },
  sort: {
    title: 'Sortierung',
    search: 'Suche',
    default: 'Standardsortierung',
    dateNew: 'Datum: Vom Neusten zum Ältesten',
    dateOld: 'Datum: Vom Ältesten zum Neuesten',
    priceLow: 'Preis niedrig bis hoch',
    priceHigh: 'Preis: Hoch bis Niedrig',
    nameA: 'Name: A bis Z',
    nameZ: 'Name: Z bis A',
  },
  shop: {
    notify: 'Benachrichtige mich',
    itemsLeft: 'artikel übrig',
    notAvailable: 'Nicht verfügbar',
    available: 'Verfügbar',
    similar: 'Auch empfehlenswert',
    similarEmpty: 'Ähnliche Produkte wurden nicht gefunden',
  },
  file: {
    download: 'Herunterladen',
    get: 'Holen',
    current: 'Aktuell',
    files: 'Dateien',
    gateTitle: 'Datei erhalten',
    gateText: 'E-Mail eintragen — der Download öffnet sich direkt hier.',
    gateAction: 'Datei anzeigen',
    gateNote: 'Deine E-Mail geht nur an diese Seite.',
    largeFile: 'Großer Download — WLAN empfohlen.',
    startDownload: 'Download starten',
    kindDocument: 'Dokumente',
    kindImage: 'Bilder',
    kindVideo: 'Video',
    kindAudio: 'Audio',
    kindArchive: 'Archive',
    kindOther: 'Andere Dateien',
  },
  music: {
    play: 'Abspielen',
    pause: 'Pause',
    previous: 'Zurück',
    next: 'Weiter',
    listen: 'Anhören',
    listenOn: 'Anhören auf',
    download: 'Herunterladen',
    presave: 'Pre-Save',
    buy: 'Kaufen',
    on: 'auf',
    tracksCount: 'Titel',
    tracklist: 'Titelliste',
    upNext: 'Als Nächstes',
    newSingle: 'Neue Single',
    addToBasket: 'In den Warenkorb',
    preview: 'Vorschau',
    hoursShort: 'Std',
    minutesShort: 'Min',
    emptyTracks: 'Noch keine Titel',
    emptyReleases: 'Noch keine Releases',
    emptyReleaseLinks: 'Noch keine Streaming-Links',
    emptyPlaylists: 'Noch keine Playlists',
  },
  podcast: {
    play: 'Abspielen',
    pause: 'Pause',
    playEpisode: 'Folge abspielen',
    playTrailer: 'Trailer abspielen',
    listen: 'Anhören',
    watch: 'Ansehen',
    latest: 'Neueste',
    guest: 'Gast',
    guests: 'Gäste',
    moreGuests: 'Weitere Gäste',
    moreGuestsCaption: 'Ganze Staffel ansehen',
    hostedBy: 'Moderiert von',
    subscribe: 'Abonnieren',
    episodes: 'Folgen',
    allEpisodes: 'Alle Folgen',
    addToQueue: 'Ab hier alles abspielen',
    left: 'übrig',
    mentioned: 'Erwähnt',
    transcript: 'Transkript',
    clip: 'Clip',
    shareClip: 'Clip teilen',
    share: 'Teilen',
    speed: 'Geschwindigkeit',
    back15: '15 Sekunden zurück',
    forward30: '30 Sekunden vor',
    askTitle: 'Fragt uns alles',
    sendQuestion: 'Frage senden',
    recordQuestion: 'Sprachfrage aufnehmen',
    leaveReview: 'Bewertung schreiben',
    supportTitle: 'Show unterstützen',
    becomeSupporter: 'Unterstützer werden',
    bestOfTitle: 'Neu hier? Fangt hiermit an',
    bestOfText: 'Folgen, die man weiterschickt',
    emptyEpisodes: 'Noch keine Folgen',
    emptyShows: 'Noch keine Shows',
    emptyShowLinks: 'Füge die Apps hinzu, in denen die Show läuft',
    emptyChapters: 'Schreibe Zeilen mit Zeitmarken in die Notizen, dann gibt es Kapitel',
    emptyTranscript: 'Füge ein Transkript als „0:00 Name: Zeile“ in die Notizen ein',
    emptyClip: 'Füge Notizen hinzu — der erste Satz wird zum Zitat',
    emptyResume: 'Noch nichts begonnen',
    emptyHosts: 'Nenne den Host in einer Folge, um diese Karte zu füllen',
    emptyGuests: 'Nenne einen Gast in einer Folge, um diese Karte zu füllen',
    emptyTopics: 'Gib den Shows eine Kategorie, um nach Thema zu filtern',
    emptyAsk: 'Füge die Frage hinzu und wohin die Antworten gehen',
    emptyRating: 'Füge deine Bewertung und ein Zitat hinzu',
    emptySupport: 'Füge deine Unterstützer-Stufen hinzu',
  },
};

export const itLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: 'In riproduzione {index} di {count}',
    chapters: 'Capitoli',
    transcript: 'Trascrizione',
    membersOnly: 'Solo per membri',
    live: 'IN DIRETTA',
    upcoming: 'In arrivo',
    lessonOf: 'Lezione {index} di {count}',
    days: 'giorni',
    hours: 'ore',
    minutes: 'min',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: 'Tutti',
    asked: 'Domanda',
    answered: 'Risposta',
    buy: 'Acquista',
    resume: 'Riprendi',
    watched: '{count} di {total} visti',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: 'In riproduzione',
    mediaPlaceholder: 'Immagine o video',
    badgeHint: 'Etichetta',
  },
  slider: {
    image: 'Immagine',
    before: 'Prima',
    after: 'Dopo',
  },
  wrongPage: {
    noItem: 'Questo elemento non esiste in questa pagina',
    noBlock: 'Questo blocco non esiste in questa pagina',
    question: 'Andare alla pagina con questo blocco?',
    goToPage: 'Vai alla pagina',
  },
  common: {
    lauching: 'In arrivo',
    showMore: 'Mostra di più',
    share: 'Condividi',
  },
  bio: {
    expand: 'Vedi di più',
  },
  timer: {
    days: 'Giorni',
    hours: 'Ore',
    min: 'Minuti',
    sec: 'Secondi',
  },
  form: {
    email: 'Email',
    name: 'Nome',
    phone: 'Telefono',
    comment: 'Commento (facoltativo)',
    address: 'Indirizzo',
    insta: 'Account Instagram',
    submitEmail: 'Abbiamo inviato le informazioni alla tua email',
    total: 'Totale',
    firstName: 'Nome',
    lastName: 'Cognome',
    enterName: 'Nome e cognome',
    enterEmail: 'Email',
    enterAddress: 'Indirizzo',
    enterComment: 'Commento Wripe (facoltativo)',
    thankYou: 'Grazie!',
    error: 'Qualcosa è andato storto',
    successEmail: 'La tua email è stata inviata con successo',
    successPhone: 'Il tuo numero di telefono è stato inviato con successo',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: 'Passaggio {current} di {total}',
    back: 'Indietro',
    next: 'Avanti',
    day: 'Giorno',
    time: 'Ora',
    chooseFile: 'Scegli un file',
    uploading: 'Caricamento…',
    uploaded: 'caricato',
    uploadFailed: 'caricamento non riuscito',
    uploadTooLarge: 'troppo grande',
    uploadLimit: 'fino a {size} MB',
    removeFile: 'Rimuovi',
    sending: 'Invio…',
    sentTitle: 'Messaggio inviato',
    sendAnother: 'Invia un altro',
    closedTitle: 'Gli invii sono chiusi',
    closedText: '',
  },
  basket: {
    addItem: 'Aggiungi al carrello',
    itemAdded: 'Aggiunto al carrello',
    orderNow: 'Ordina ora',
    goToCart: 'Vai al carrello',
    continue: 'Continua lo shopping',
    shoppingCart: 'Carrello',
    submitOrder: 'Invia ordine',
    cancel: 'Annulla',
    items: 'Articoli',
    total: 'Totale',
    shipping: 'Spedizione',
    shippingName: 'Inserisci nome e cognome',
    shippingEmail: 'Inserisci email',
    shippingAddress: 'Inserisci indirizzo',
    shippingComment: 'Inserisci commento (facoltativo)',
    paymentMethod: 'Metodo di pagamento',
    stripe: 'Paga con Stripe',
    wayforpay: 'Carta di debito o credito',
    cash: 'Contanti',
    buttonProcessOrder: 'Elabora il tuo ordine',
    titleEmpty: 'Il tuo carrello è vuoto',
    subtitleEmpty: 'Sembra che tu non abbia ancora aggiunto nulla al carrello',
    bthShopNow: 'Acquista ora',
    successOrder: 'Il tuo ordine è stato inviato con successo!',
    errorOrder: 'Il tuo ordine non è stato inviato',
    bthHome: 'Vai alla home',
    quantity: 'Qtà',
  },
  contacts: {
    ask: 'Chiedi su',
    orderWhatsApp: 'Ordina su WhatsApp',
  },
  features: {
    swipe: 'Scorri',
    more: 'Scopri di più',
  },
  // Not translated yet — English until a translation lands (this file has no EN fallback).
  team: {
    getInTouch: 'Get in touch',
    profile: 'Profile',
    people: 'people',
    swipe: 'Swipe',
    otherPeople: 'Also here',
  },
  donation: {
    textBuy: 'Acquista',
    fieldComment: 'Scrivi qualcosa di carino...(facoltativo)',
    buttonSupport: 'Supporto',
  },
  category: {
    all: 'Tutti',
    noItems: 'Nessun articolo',
  },
  // Not translated yet — English until a translation lands.
  blog: {
    read: 'Read',
    min: 'min',
    minRead: 'min read',
    all: 'All',
    pinned: 'Pinned',
    showMore: 'Show more',
  },
  // Not translated yet — English until a translation lands.
  faq: {
    noResults: 'Nothing matches that search',
  },
  // Not translated yet — English until a translation lands.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  // Not translated yet — English until a translation lands.
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Ask anything...',
      continueChat: 'Continue chat',
      noResponse: 'No response',
      sendError: 'Something went wrong. Please try again.',
      defaultBubbleTitle: 'AI Chat',
      launchLabel: 'Start the conversation',
      startChatLabel: 'Start a chat',
    },
  },
  link: {
    visitLink: 'Visita link',
  },
  map: {
    directions: 'Indicazioni stradali',
    copyAddress: 'Copia indirizzo',
    call: 'Chiama',
    deliveryAddress: 'Inserisci il tuo indirizzo',
    deliveryCheck: 'Verifica la distanza',
    searchPoint: 'Trova il punto più vicino',
  },
  // Not translated yet — English until a translation lands.
  gallery: {
    photos: 'photos',
    photo: 'photo',
    all: 'All',
    open: 'Open',
    openGallery: 'Open the gallery',
  },
  pageList: {
    navigation: 'Navigazione',
    previous: 'Precedente',
    next: 'Successiva',
    // Not translated yet — English until a translation lands.
    allPages: 'All pages of this section',
  },
  footer: {
    subscribe: 'Iscriviti',
    subscribed: 'Grazie — sei nella lista.',
    emailPlaceholder: 'you@email.com',
    app: 'App',
    payment: 'Pagamento',
    language: 'Lingua',
    currencyAndShipping: 'Valuta e spedizione',
    messengers: 'Messaggistica',
  },
  error: {
    correctEmail: "Inserisci un'email valida",
    emptyField: 'il campo non può essere vuoto',
  },
  sort: {
    title: 'Ordina',
    search: 'Cerca',
    default: 'Ordinamento predefinito',
    dateNew: 'Data: dal più recente al meno recente',
    dateOld: 'Data: dal meno recente al più recente',
    priceLow: 'Prezzo: dal più basso al più alto',
    priceHigh: 'Prezzo: dal più alto al più basso',
    nameA: 'Nome: dalla A alla Z',
    nameZ: 'Nome: dalla Z alla A',
  },
  shop: {
    notify: 'Avvisami',
    itemsLeft: 'articoli rimasti',
    notAvailable: 'Non disponibile',
    available: 'Disponibile',
    similar: 'Potrebbe interessarti anche',
    similarEmpty: 'Nessun prodotto simile trovato',
  },
  file: {
    download: 'Scarica',
    get: 'Ottieni',
    current: 'Attuale',
    files: 'file',
    gateTitle: 'Ottieni il file',
    gateText: 'Lascia la tua email: il download si apre qui.',
    gateAction: 'Mostra il file',
    gateNote: 'La tua email arriva solo a questa pagina.',
    largeFile: 'Download pesante — meglio con il Wi-Fi.',
    startDownload: 'Avvia il download',
    kindDocument: 'Documenti',
    kindImage: 'Immagini',
    kindVideo: 'Video',
    kindAudio: 'Audio',
    kindArchive: 'Archivi',
    kindOther: 'Altri file',
  },
  music: {
    play: 'Riproduci',
    pause: 'Pausa',
    previous: 'Precedente',
    next: 'Successivo',
    listen: 'Ascolta',
    listenOn: 'Ascolta su',
    download: 'Scarica',
    presave: 'Pre-salva',
    buy: 'Acquista',
    on: 'su',
    tracksCount: 'brani',
    tracklist: 'Tracklist',
    upNext: 'Il prossimo',
    newSingle: 'Nuovo singolo',
    addToBasket: 'Aggiungi al carrello',
    preview: 'anteprima',
    hoursShort: 'h',
    minutesShort: 'min',
    emptyTracks: 'Ancora nessun brano',
    emptyReleases: 'Ancora nessuna uscita',
    emptyReleaseLinks: 'Ancora nessun link di streaming',
    emptyPlaylists: 'Ancora nessuna playlist',
  },
  podcast: {
    play: 'Riproduci',
    pause: 'Pausa',
    playEpisode: 'Riproduci episodio',
    playTrailer: 'Riproduci trailer',
    listen: 'Ascolta',
    watch: 'Guarda',
    latest: 'Recente',
    guest: 'Ospite',
    guests: 'Ospiti',
    moreGuests: 'Altri ospiti',
    moreGuestsCaption: 'Vedi tutta la stagione',
    hostedBy: 'Condotto da',
    subscribe: 'Iscriviti',
    episodes: 'episodi',
    allEpisodes: 'Tutti gli episodi',
    addToQueue: 'Riproduci tutto da qui',
    left: 'rimanenti',
    mentioned: 'Menzionato',
    transcript: 'Trascrizione',
    clip: 'Clip',
    shareClip: 'Condividi questa clip',
    share: 'Condividi',
    speed: 'Velocità',
    back15: 'Indietro di 15 secondi',
    forward30: 'Avanti di 30 secondi',
    askTitle: 'Chiedeteci qualsiasi cosa',
    sendQuestion: 'Invia domanda',
    recordQuestion: 'Registra una domanda vocale',
    leaveReview: 'Lascia una recensione',
    supportTitle: 'Sostieni il programma',
    becomeSupporter: 'Diventa sostenitore',
    bestOfTitle: 'Nuovo qui? Inizia da questi',
    bestOfText: 'Gli episodi che si mandano agli amici',
    emptyEpisodes: 'Ancora nessun episodio',
    emptyShows: 'Ancora nessun programma',
    emptyShowLinks: 'Aggiungi le app dove si trova il programma',
    emptyChapters: 'Scrivi righe con i minutaggi nelle note per avere i capitoli',
    emptyTranscript: 'Incolla una trascrizione nelle note come "0:00 Nome: battuta"',
    emptyClip: 'Aggiungi le note — la prima frase diventa la citazione',
    emptyResume: 'Niente di iniziato',
    emptyHosts: 'Indica il conduttore in un episodio per riempire questa card',
    emptyGuests: 'Indica un ospite in un episodio per riempire questa card',
    emptyTopics: 'Dai una categoria ai programmi per filtrare per tema',
    emptyAsk: 'Aggiungi la domanda e dove arrivano le risposte',
    emptyRating: 'Aggiungi il voto e una recensione da citare',
    emptySupport: 'Aggiungi i tuoi livelli di sostegno',
  },
};

export const trLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: '{count} videodan {index}. oynatılıyor',
    chapters: 'Bölümler',
    transcript: 'Transkript',
    membersOnly: 'Yalnızca üyeler',
    live: 'CANLI',
    upcoming: 'Yakında',
    lessonOf: '{count} dersten {index}.',
    days: 'gün',
    hours: 'sa',
    minutes: 'dk',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: 'Tümü',
    asked: 'Soru',
    answered: 'Cevap',
    buy: 'Satın al',
    resume: 'Devam et',
    watched: '{total} videodan {count} tanesi izlendi',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: 'Oynatılıyor',
    mediaPlaceholder: 'Görsel veya video',
    badgeHint: 'Etiket',
  },
  slider: {
    image: 'Görsel',
    before: 'Öncesi',
    after: 'Sonrası',
  },
  wrongPage: {
    noItem: 'Bu öğe bu sayfada mevcut değil',
    noBlock: 'Bu blok bu sayfada mevcut değil',
    question: 'Bu bloğun bulunduğu sayfaya git?',
    goToPage: 'Sayfaya git',
  },
  common: {
    lauching: 'Başlatılıyor',
    showMore: 'Daha fazla göster',
    share: 'Paylaş',
  },
  bio: {
    expand: 'Daha fazlasını gör',
  },
  timer: {
    days: 'Gün',
    hours: 'Saat',
    min: 'Dakika',
    sec: 'Saniye',
  },
  form: {
    email: 'Email',
    name: 'Ad',
    phone: 'Telefon',
    comment: 'Yorum (isteğe bağlı)',
    address: 'Adres',
    insta: 'Instagram hesabı',
    submitEmail: 'Bilgileri email adresinize gönderdik',
    total: 'Toplam',
    firstName: 'Ad',
    lastName: 'Soyad',
    enterName: 'Ad ve Soyad',
    enterEmail: 'Email',
    enterAddress: 'Adres',
    enterComment: 'Wripe Yorumu (isteğe bağlı)',
    thankYou: 'Teşekkürler!',
    error: 'Bir şeyler ters gitti',
    successEmail: 'Email adresiniz başarıyla gönderildi',
    successPhone: 'Telefon numaranız başarıyla gönderildi',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: 'Adım {current} / {total}',
    back: 'Geri',
    next: 'İleri',
    day: 'Gün',
    time: 'Saat',
    chooseFile: 'Dosya seç',
    uploading: 'Yükleniyor…',
    uploaded: 'yüklendi',
    uploadFailed: 'yükleme başarısız',
    uploadTooLarge: 'çok büyük',
    uploadLimit: '{size} MB’a kadar',
    removeFile: 'Kaldır',
    sending: 'Gönderiliyor…',
    sentTitle: 'Mesaj gönderildi',
    sendAnother: 'Bir tane daha gönder',
    closedTitle: 'Gönderimler kapalı',
    closedText: '',
  },
  basket: {
    addItem: 'Sepete ekle',
    itemAdded: 'Sepete eklendi',
    orderNow: 'Hemen sipariş ver',
    goToCart: 'Sepete git',
    continue: 'Alışverişe devam et',
    shoppingCart: 'Alışveriş sepeti',
    submitOrder: 'Siparişi gönder',
    cancel: 'İptal',
    items: 'Ürünler',
    total: 'Toplam',
    shipping: 'Kargo',
    shippingName: 'Ad ve Soyad girin',
    shippingEmail: 'Email girin',
    shippingAddress: 'Adres girin',
    shippingComment: 'Yorum girin (isteğe bağlı)',
    paymentMethod: 'Ödeme Yöntemi',
    stripe: 'Stripe ile öde',
    wayforpay: 'Banka veya Kredi Kartı',
    cash: 'Nakit',
    buttonProcessOrder: 'Siparişinizi tamamlayın',
    titleEmpty: 'Sepetiniz boş',
    subtitleEmpty: 'Görünüşe göre sepetinize henüz bir şey eklemediniz',
    bthShopNow: 'Alışverişe başla',
    successOrder: 'Siparişiniz başarıyla gönderildi!',
    errorOrder: 'Siparişiniz gönderilmedi',
    bthHome: 'Ana sayfaya git',
    quantity: 'Adet',
  },
  contacts: {
    ask: 'Sor',
    orderWhatsApp: "WhatsApp'tan sipariş ver",
  },
  features: {
    swipe: 'Kaydır',
    more: 'Daha fazla',
  },
  // Not translated yet — English until a translation lands (this file has no EN fallback).
  team: {
    getInTouch: 'Get in touch',
    profile: 'Profile',
    people: 'people',
    swipe: 'Swipe',
    otherPeople: 'Also here',
  },
  donation: {
    textBuy: 'Satın al',
    fieldComment: 'Güzel bir şey söyleyin...(isteğe bağlı)',
    buttonSupport: 'Destek',
  },
  category: {
    all: 'Tümü',
    noItems: 'Ürün yok',
  },
  // Not translated yet — English until a translation lands.
  blog: {
    read: 'Read',
    min: 'min',
    minRead: 'min read',
    all: 'All',
    pinned: 'Pinned',
    showMore: 'Show more',
  },
  // Not translated yet — English until a translation lands.
  faq: {
    noResults: 'Nothing matches that search',
  },
  // Not translated yet — English until a translation lands.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  // Not translated yet — English until a translation lands.
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Ask anything...',
      continueChat: 'Continue chat',
      noResponse: 'No response',
      sendError: 'Something went wrong. Please try again.',
      defaultBubbleTitle: 'AI Chat',
      launchLabel: 'Start the conversation',
      startChatLabel: 'Start a chat',
    },
  },
  link: {
    visitLink: 'Bağlantıyı ziyaret et',
  },
  map: {
    directions: 'Yol tarifi al',
    copyAddress: 'Adresi kopyala',
    call: 'Ara',
    deliveryAddress: 'Adresinizi girin',
    deliveryCheck: 'Mesafeyi kontrol et',
    searchPoint: 'En yakın noktayı bul',
  },
  // Not translated yet — English until a translation lands.
  gallery: {
    photos: 'photos',
    photo: 'photo',
    all: 'All',
    open: 'Open',
    openGallery: 'Open the gallery',
  },
  pageList: {
    navigation: 'Gezinme',
    previous: 'Önceki',
    next: 'Sonraki',
    // Not translated yet — English until a translation lands.
    allPages: 'All pages of this section',
  },
  footer: {
    subscribe: 'Abone ol',
    subscribed: 'Teşekkürler — listedesiniz.',
    emailPlaceholder: 'you@email.com',
    app: 'Uygulama',
    payment: 'Ödeme',
    language: 'Dil',
    currencyAndShipping: 'Para birimi ve teslimat',
    messengers: 'Mesajlaşma',
  },
  error: {
    correctEmail: 'Geçerli bir e-posta girin',
    emptyField: 'alan boş bırakılamaz',
  },
  sort: {
    title: 'Sırala',
    search: 'Ara',
    default: 'Varsayılan sıralama',
    dateNew: 'Tarih: Yeniden eskiye',
    dateOld: 'Tarih: Eskiden yeniye',
    priceLow: 'Fiyat: Düşükten yükseğe',
    priceHigh: 'Fiyat: Yüksekten düşüğe',
    nameA: "İsim: A'dan Z'ye",
    nameZ: "İsim: Z'den A'ya",
  },
  shop: {
    notify: 'Bana haber ver',
    itemsLeft: 'ürün kaldı',
    notAvailable: 'Mevcut değil',
    available: 'Mevcut',
    similar: 'Bunları da beğenebilirsin',
    similarEmpty: 'Benzer ürün bulunamadı',
  },
  file: {
    download: 'İndir',
    get: 'Al',
    current: 'Güncel',
    files: 'dosya',
    gateTitle: 'Dosyayı al',
    gateText: 'E-postanı bırak, indirme hemen burada açılsın.',
    gateAction: 'Dosyayı göster',
    gateNote: 'E-postan yalnızca bu sayfanın sahibine gider.',
    largeFile: 'Büyük indirme — Wi-Fi önerilir.',
    startDownload: 'İndirmeyi başlat',
    kindDocument: 'Belgeler',
    kindImage: 'Görseller',
    kindVideo: 'Video',
    kindAudio: 'Ses',
    kindArchive: 'Arşivler',
    kindOther: 'Diğer dosyalar',
  },
  music: {
    play: 'Çal',
    pause: 'Duraklat',
    previous: 'Önceki',
    next: 'Sonraki',
    listen: 'Dinle',
    listenOn: 'Dinle:',
    download: 'İndir',
    presave: 'Ön kaydet',
    buy: 'Satın al',
    on: '·',
    tracksCount: 'parça',
    tracklist: 'Parça listesi',
    upNext: 'Sırada',
    newSingle: 'Yeni single',
    addToBasket: 'Sepete ekle',
    preview: 'önizleme',
    hoursShort: 'sa',
    minutesShort: 'dk',
    emptyTracks: 'Henüz parça yok',
    emptyReleases: 'Henüz yayın yok',
    emptyReleaseLinks: 'Henüz streaming bağlantısı yok',
    emptyPlaylists: 'Henüz çalma listesi yok',
  },
  podcast: {
    play: 'Çal',
    pause: 'Duraklat',
    playEpisode: 'Bölümü çal',
    playTrailer: 'Fragmanı çal',
    listen: 'Dinle',
    watch: 'İzle',
    latest: 'Son',
    guest: 'Konuk',
    guests: 'Konuklar',
    moreGuests: 'Daha fazla konuk',
    moreGuestsCaption: 'Tüm sezonu gör',
    hostedBy: 'Sunan',
    subscribe: 'Abone ol',
    episodes: 'bölüm',
    allEpisodes: 'Tüm bölümler',
    addToQueue: 'Buradan hepsini çal',
    left: 'kaldı',
    mentioned: 'Bahsedilenler',
    transcript: 'Metin',
    clip: 'Klip',
    shareClip: 'Bu klibi paylaş',
    share: 'Paylaş',
    speed: 'Hız',
    back15: '15 saniye geri',
    forward30: '30 saniye ileri',
    askTitle: 'Bize her şeyi sorun',
    sendQuestion: 'Soru gönder',
    recordQuestion: 'Sesli soru kaydet',
    leaveReview: 'Yorum bırak',
    supportTitle: 'Programı destekle',
    becomeSupporter: 'Destekçi ol',
    bestOfTitle: 'Yeni misiniz? Bunlarla başlayın',
    bestOfText: 'İnsanların arkadaşlarına yolladığı bölümler',
    emptyEpisodes: 'Henüz bölüm yok',
    emptyShows: 'Henüz program yok',
    emptyShowLinks: 'Programın olduğu uygulamaları ekleyin',
    emptyChapters: 'Bölüm notlarına zaman damgalı satırlar yazın, bölümler oluşsun',
    emptyTranscript: 'Notlara metni "0:00 Ad: satır" biçiminde yapıştırın',
    emptyClip: 'Not ekleyin — ilk cümle alıntı olur',
    emptyResume: 'Henüz başlanmadı',
    emptyHosts: 'Kartı doldurmak için bir bölümde sunucuyu belirtin',
    emptyGuests: 'Kartı doldurmak için bir bölümde konuğu belirtin',
    emptyTopics: 'Konuya göre süzmek için programlara kategori verin',
    emptyAsk: 'Soruyu ve yanıtların gideceği yeri ekleyin',
    emptyRating: 'Puanınızı ve alıntılanacak bir yorumu ekleyin',
    emptySupport: 'Destek seviyelerinizi ekleyin',
  },
};

export const plLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: 'Odtwarzanie {index} z {count}',
    chapters: 'Rozdziały',
    transcript: 'Transkrypcja',
    membersOnly: 'Tylko dla członków',
    live: 'NA ŻYWO',
    upcoming: 'Wkrótce',
    lessonOf: 'Lekcja {index} z {count}',
    days: 'dni',
    hours: 'godz.',
    minutes: 'min',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: 'Wszystkie',
    asked: 'Pytanie',
    answered: 'Odpowiedź',
    buy: 'Kup',
    resume: 'Wznów',
    watched: 'Obejrzano {count} z {total}',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: 'Odtwarzanie',
    mediaPlaceholder: 'Obraz lub wideo',
    badgeHint: 'Plakietka',
  },
  slider: {
    image: 'Obraz',
    before: 'Przed',
    after: 'Po',
  },
  wrongPage: {
    noItem: 'Na tej stronie nie ma takiego elementu',
    noBlock: 'Na tej stronie nie ma takiego bloku',
    question: 'Przejść do strony z tym blokiem?',
    goToPage: 'Przejdź do strony',
  },
  common: {
    lauching: 'Uruchamianie',
    showMore: 'Pokaż więcej',
    share: 'Udostępnij',
  },
  bio: {
    expand: 'Zobacz więcej',
  },
  timer: {
    days: 'Dni',
    hours: 'Godziny',
    min: 'Minuty',
    sec: 'Sekundy',
  },
  form: {
    email: 'E-mail',
    name: 'Imię',
    phone: 'Telefon',
    comment: 'Komentarz (opcjonalnie)',
    address: 'Adres',
    insta: 'Konto na Instagramie',
    submitEmail: 'Wysłaliśmy informacje na Twój e-mail',
    total: 'Razem',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    enterName: 'Imię i nazwisko',
    enterEmail: 'E-mail',
    enterAddress: 'Adres',
    enterComment: 'Wpisz komentarz (opcjonalnie)',
    thankYou: 'Dziękujemy!',
    error: 'Coś poszło nie tak',
    successEmail: 'Twój e-mail został pomyślnie wysłany',
    successPhone: 'Twój numer telefonu został pomyślnie wysłany',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: 'Krok {current} z {total}',
    back: 'Wstecz',
    next: 'Dalej',
    day: 'Dzień',
    time: 'Godzina',
    chooseFile: 'Wybierz plik',
    uploading: 'Przesyłanie…',
    uploaded: 'przesłano',
    uploadFailed: 'przesyłanie nieudane',
    uploadTooLarge: 'za duży',
    uploadLimit: 'do {size} MB',
    removeFile: 'Usuń',
    sending: 'Wysyłanie…',
    sentTitle: 'Wiadomość wysłana',
    sendAnother: 'Wyślij kolejną',
    closedTitle: 'Zgłoszenia są zamknięte',
    closedText: '',
  },
  basket: {
    addItem: 'Dodaj do koszyka',
    itemAdded: 'Dodano do koszyka',
    orderNow: 'Zamów teraz',
    goToCart: 'Przejdź do koszyka',
    continue: 'Kontynuuj zakupy',
    shoppingCart: 'Koszyk',
    submitOrder: 'Złóż zamówienie',
    cancel: 'Anuluj',
    items: 'Produkty',
    total: 'Razem',
    shipping: 'Dostawa',
    shippingName: 'Wpisz imię i nazwisko',
    shippingEmail: 'Wpisz e-mail',
    shippingAddress: 'Wpisz adres',
    shippingComment: 'Wpisz komentarz (opcjonalnie)',
    paymentMethod: 'Metoda płatności',
    stripe: 'Zapłać przez Stripe',
    wayforpay: 'Karta debetowa lub kredytowa',
    cash: 'Gotówka',
    buttonProcessOrder: 'Przetwórz zamówienie',
    titleEmpty: 'Twój koszyk jest pusty',
    subtitleEmpty: 'Wygląda na to, że nie dodałeś jeszcze nic do koszyka',
    bthShopNow: 'Kup teraz',
    successOrder: 'Twoje zamówienie zostało pomyślnie złożone!',
    errorOrder: 'Twoje zamówienie nie zostało złożone',
    bthHome: 'Przejdź do strony głównej',
    quantity: 'Ilość',
  },
  contacts: {
    ask: 'Zapytaj w',
    orderWhatsApp: 'Zamów przez WhatsApp',
  },
  features: {
    swipe: 'Przesuń',
    more: 'Dowiedz się więcej',
  },
  // Not translated yet — English until a translation lands (this file has no EN fallback).
  team: {
    getInTouch: 'Get in touch',
    profile: 'Profile',
    people: 'people',
    swipe: 'Swipe',
    otherPeople: 'Also here',
  },
  donation: {
    textBuy: 'Kup',
    fieldComment: 'Napisz coś miłego...(opcjonalnie)',
    buttonSupport: 'Wesprzyj',
  },
  category: {
    all: 'Wszystkie',
    noItems: 'Brak elementów',
  },
  // Not translated yet — English until a translation lands.
  blog: {
    read: 'Read',
    min: 'min',
    minRead: 'min read',
    all: 'All',
    pinned: 'Pinned',
    showMore: 'Show more',
  },
  // Not translated yet — English until a translation lands.
  faq: {
    noResults: 'Nothing matches that search',
  },
  // Not translated yet — English until a translation lands.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  // Not translated yet — English until a translation lands.
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Ask anything...',
      continueChat: 'Continue chat',
      noResponse: 'No response',
      sendError: 'Something went wrong. Please try again.',
      defaultBubbleTitle: 'AI Chat',
      launchLabel: 'Start the conversation',
      startChatLabel: 'Start a chat',
    },
  },
  link: {
    visitLink: 'Odwiedź link',
  },
  map: {
    directions: 'Wyznacz trasę',
    copyAddress: 'Skopiuj adres',
    call: 'Zadzwoń',
    deliveryAddress: 'Wpisz swój adres',
    deliveryCheck: 'Sprawdź odległość',
    searchPoint: 'Znajdź najbliższy punkt',
  },
  // Not translated yet — English until a translation lands.
  gallery: {
    photos: 'photos',
    photo: 'photo',
    all: 'All',
    open: 'Open',
    openGallery: 'Open the gallery',
  },
  pageList: {
    navigation: 'Nawigacja',
    previous: 'Poprzednia',
    next: 'Następna',
    // Not translated yet — English until a translation lands.
    allPages: 'All pages of this section',
  },
  footer: {
    subscribe: 'Zapisz się',
    subscribed: 'Dziękujemy — jesteś na liście.',
    emailPlaceholder: 'you@email.com',
    app: 'Aplikacja',
    payment: 'Płatność',
    language: 'Język',
    currencyAndShipping: 'Waluta i dostawa',
    messengers: 'Komunikatory',
  },
  error: {
    correctEmail: 'Wpisz poprawny e-mail',
    emptyField: 'pole nie może być puste',
  },
  sort: {
    title: 'Sortuj',
    search: 'Szukaj',
    default: 'Sortowanie domyślne',
    dateNew: 'Data: od najnowszych',
    dateOld: 'Data: od najstarszych',
    priceLow: 'Cena: od najniższej',
    priceHigh: 'Cena: od najwyższej',
    nameA: 'Nazwa: od A do Z',
    nameZ: 'Nazwa: od Z do A',
  },
  shop: {
    notify: 'Powiadom mnie',
    itemsLeft: 'szt. pozostało',
    notAvailable: 'Niedostępne',
    available: 'Dostępne',
    similar: 'Może Ci się spodobać',
    similarEmpty: 'Nie znaleziono podobnych produktów',
  },
  file: {
    download: 'Pobierz',
    get: 'Odbierz',
    current: 'Aktualna',
    files: 'plików',
    gateTitle: 'Odbierz plik',
    gateText: 'Zostaw e-mail — pobieranie otworzy się tutaj.',
    gateAction: 'Pokaż plik',
    gateNote: 'Twój e-mail trafia tylko do właściciela tej strony.',
    largeFile: 'Duży plik — lepiej przez Wi-Fi.',
    startDownload: 'Rozpocznij pobieranie',
    kindDocument: 'Dokumenty',
    kindImage: 'Obrazy',
    kindVideo: 'Wideo',
    kindAudio: 'Audio',
    kindArchive: 'Archiwa',
    kindOther: 'Inne pliki',
  },
  music: {
    play: 'Odtwórz',
    pause: 'Pauza',
    previous: 'Poprzedni',
    next: 'Następny',
    listen: 'Słuchaj',
    listenOn: 'Słuchaj w',
    download: 'Pobierz',
    presave: 'Pre-save',
    buy: 'Kup',
    on: 'w',
    tracksCount: 'utworów',
    tracklist: 'Lista utworów',
    upNext: 'Następne',
    newSingle: 'Nowy singiel',
    addToBasket: 'Dodaj do koszyka',
    preview: 'zapowiedź',
    hoursShort: 'godz',
    minutesShort: 'min',
    emptyTracks: 'Nie ma jeszcze utworów',
    emptyReleases: 'Nie ma jeszcze wydań',
    emptyReleaseLinks: 'Nie ma jeszcze linków do streamingu',
    emptyPlaylists: 'Nie ma jeszcze playlist',
  },
  podcast: {
    play: 'Odtwórz',
    pause: 'Pauza',
    playEpisode: 'Odtwórz odcinek',
    playTrailer: 'Odtwórz zwiastun',
    listen: 'Słuchaj',
    watch: 'Oglądaj',
    latest: 'Najnowsze',
    guest: 'Gość',
    guests: 'Goście',
    moreGuests: 'Więcej gości',
    moreGuestsCaption: 'Zobacz cały sezon',
    hostedBy: 'Prowadzą',
    subscribe: 'Subskrybuj',
    episodes: 'odcinków',
    allEpisodes: 'Wszystkie odcinki',
    addToQueue: 'Odtwórz wszystko od tego miejsca',
    left: 'zostało',
    mentioned: 'Wspomniane',
    transcript: 'Transkrypcja',
    clip: 'Klip',
    shareClip: 'Udostępnij ten klip',
    share: 'Udostępnij',
    speed: 'Prędkość',
    back15: 'Cofnij o 15 sekund',
    forward30: 'Do przodu o 30 sekund',
    askTitle: 'Zapytaj nas o wszystko',
    sendQuestion: 'Wyślij pytanie',
    recordQuestion: 'Nagraj pytanie głosowe',
    leaveReview: 'Zostaw recenzję',
    supportTitle: 'Wesprzyj podcast',
    becomeSupporter: 'Zostań patronem',
    bestOfTitle: 'Nowy tutaj? Zacznij od tych',
    bestOfText: 'Odcinki, które ludzie wysyłają znajomym',
    emptyEpisodes: 'Nie ma jeszcze odcinków',
    emptyShows: 'Nie ma jeszcze programów',
    emptyShowLinks: 'Dodaj aplikacje, w których jest ten program',
    emptyChapters: 'Wpisz w notatkach linie ze znacznikami czasu, a powstaną rozdziały',
    emptyTranscript: 'Wklej transkrypcję do notatek jako „0:00 Imię: kwestia”',
    emptyClip: 'Dodaj notatki — pierwsze zdanie stanie się cytatem',
    emptyResume: 'Nic jeszcze nie zaczęte',
    emptyHosts: 'Wskaż prowadzącego w odcinku, aby wypełnić tę kartę',
    emptyGuests: 'Wskaż gościa w odcinku, aby wypełnić tę kartę',
    emptyTopics: 'Nadaj programom kategorię, aby filtrować po temacie',
    emptyAsk: 'Dodaj pytanie i miejsce, gdzie trafiają odpowiedzi',
    emptyRating: 'Dodaj ocenę i recenzję do zacytowania',
    emptySupport: 'Dodaj swoje poziomy wsparcia',
  },
};
export const zhLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: '正在播放第 {index} 个，共 {count} 个',
    chapters: '章节',
    transcript: '文字稿',
    membersOnly: '仅限会员',
    live: '直播中',
    upcoming: '即将开始',
    lessonOf: '第 {index} 课，共 {count} 课',
    days: '天',
    hours: '小时',
    minutes: '分',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: '全部',
    asked: '提问',
    answered: '回答',
    buy: '购买',
    resume: '继续观看',
    watched: '已观看 {count}/{total}',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: '播放中',
    mediaPlaceholder: '图片或视频',
    badgeHint: '徽章',
  },
  slider: {
    image: '图片',
    before: '之前',
    after: '之后',
  },
  wrongPage: {
    noItem: '此页面上没有该项目',
    noBlock: '此页面上没有该板块',
    question: '前往包含该板块的页面？',
    goToPage: '前往页面',
  },
  common: {
    lauching: '正在启动',
    showMore: '显示更多',
    share: '分享',
  },
  bio: {
    expand: '查看更多',
  },
  timer: {
    days: '天',
    hours: '小时',
    min: '分钟',
    sec: '秒',
  },
  form: {
    email: '电子邮箱',
    name: '姓名',
    phone: '电话',
    comment: '备注（可选）',
    address: '地址',
    insta: 'Instagram 账号',
    submitEmail: '我们已将信息发送到您的邮箱',
    total: '合计',
    firstName: '名字',
    lastName: '姓氏',
    enterName: '姓名',
    enterEmail: '电子邮箱',
    enterAddress: '地址',
    enterComment: '填写备注（可选）',
    thankYou: '谢谢！',
    error: '出了点问题',
    successEmail: '您的邮箱已成功提交',
    successPhone: '您的电话已成功提交',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: '第 {current} 步，共 {total} 步',
    back: '返回',
    next: '下一步',
    day: '日期',
    time: '时间',
    chooseFile: '选择文件',
    uploading: '上传中…',
    uploaded: '已上传',
    uploadFailed: '上传失败',
    uploadTooLarge: '文件过大',
    uploadLimit: '最大 {size} MB',
    removeFile: '移除',
    sending: '发送中…',
    sentTitle: '消息已发送',
    sendAnother: '再发一条',
    closedTitle: '已停止接收提交',
    closedText: '',
  },
  basket: {
    addItem: '加入购物车',
    itemAdded: '已加入购物车',
    orderNow: '立即下单',
    goToCart: '前往购物车',
    continue: '继续购物',
    shoppingCart: '购物车',
    submitOrder: '提交订单',
    cancel: '取消',
    items: '商品',
    total: '合计',
    shipping: '配送',
    shippingName: '请输入姓名',
    shippingEmail: '请输入电子邮箱',
    shippingAddress: '请输入地址',
    shippingComment: '请输入备注（可选）',
    paymentMethod: '支付方式',
    stripe: '使用 Stripe 支付',
    wayforpay: '借记卡或信用卡',
    cash: '现金',
    buttonProcessOrder: '处理您的订单',
    titleEmpty: '您的购物车是空的',
    subtitleEmpty: '看起来您还没有添加任何商品到购物车',
    bthShopNow: '立即购买',
    successOrder: '您的订单已成功提交！',
    errorOrder: '您的订单未能提交',
    bthHome: '返回首页',
    quantity: '数量',
  },
  contacts: {
    ask: '咨询于',
    orderWhatsApp: '通过 WhatsApp 下单',
  },
  features: {
    swipe: '滑动',
    more: '了解更多',
  },
  // Not translated yet — English until a translation lands (this file has no EN fallback).
  team: {
    getInTouch: 'Get in touch',
    profile: 'Profile',
    people: 'people',
    swipe: 'Swipe',
    otherPeople: 'Also here',
  },
  donation: {
    textBuy: '购买',
    fieldComment: '说点好话吧……（可选）',
    buttonSupport: '支持',
  },
  category: {
    all: '全部',
    noItems: '暂无项目',
  },
  // Not translated yet — English until a translation lands.
  blog: {
    read: 'Read',
    min: 'min',
    minRead: 'min read',
    all: 'All',
    pinned: 'Pinned',
    showMore: 'Show more',
  },
  // Not translated yet — English until a translation lands.
  faq: {
    noResults: 'Nothing matches that search',
  },
  // Not translated yet — English until a translation lands.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  // Not translated yet — English until a translation lands.
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Ask anything...',
      continueChat: 'Continue chat',
      noResponse: 'No response',
      sendError: 'Something went wrong. Please try again.',
      defaultBubbleTitle: 'AI Chat',
      launchLabel: 'Start the conversation',
      startChatLabel: 'Start a chat',
    },
  },
  link: {
    visitLink: '访问链接',
  },
  map: {
    directions: '获取路线',
    copyAddress: '复制地址',
    call: '打电话',
    deliveryAddress: '输入您的地址',
    deliveryCheck: '查看距离',
    searchPoint: '查找最近的地点',
  },
  // Not translated yet — English until a translation lands.
  gallery: {
    photos: 'photos',
    photo: 'photo',
    all: 'All',
    open: 'Open',
    openGallery: 'Open the gallery',
  },
  pageList: {
    navigation: '导航',
    previous: '上一页',
    next: '下一页',
    // Not translated yet — English until a translation lands.
    allPages: 'All pages of this section',
  },
  footer: {
    subscribe: '订阅',
    subscribed: '谢谢，已加入订阅列表。',
    emailPlaceholder: 'you@email.com',
    app: '应用',
    payment: '支付',
    language: '语言',
    currencyAndShipping: '货币与配送',
    messengers: '即时通讯',
  },
  error: {
    correctEmail: '请输入正确的电子邮箱',
    emptyField: '此字段不能为空',
  },
  sort: {
    title: '排序',
    search: '搜索',
    default: '默认排序',
    dateNew: '日期：从新到旧',
    dateOld: '日期：从旧到新',
    priceLow: '价格：从低到高',
    priceHigh: '价格：从高到低',
    nameA: '名称：A 到 Z',
    nameZ: '名称：Z 到 A',
  },
  shop: {
    notify: '通知我',
    itemsLeft: '件剩余',
    notAvailable: '无货',
    available: '有货',
    similar: '您可能还喜欢',
    similarEmpty: '未找到类似商品',
  },
  file: {
    download: '下载',
    get: '获取',
    current: '当前版本',
    files: '个文件',
    gateTitle: '获取文件',
    gateText: '留下邮箱，下载链接就在这里打开。',
    gateAction: '显示文件',
    gateNote: '您的邮箱只会发送给本页面的主人。',
    largeFile: '文件较大，建议使用 Wi-Fi。',
    startDownload: '开始下载',
    kindDocument: '文档',
    kindImage: '图片',
    kindVideo: '视频',
    kindAudio: '音频',
    kindArchive: '压缩包',
    kindOther: '其他文件',
  },
  music: {
    play: '播放',
    pause: '暂停',
    previous: '上一首',
    next: '下一首',
    listen: '收听',
    listenOn: '收听:',
    download: '下载',
    presave: '预先保存',
    buy: '购买',
    on: '·',
    tracksCount: '首',
    tracklist: '曲目列表',
    upNext: '接下来',
    newSingle: '新单曲',
    addToBasket: '加入购物车',
    preview: '试听',
    hoursShort: '小时',
    minutesShort: '分钟',
    emptyTracks: '还没有曲目',
    emptyReleases: '还没有发行',
    emptyReleaseLinks: '还没有流媒体链接',
    emptyPlaylists: '还没有播放列表',
  },
  podcast: {
    play: '播放',
    pause: '暂停',
    playEpisode: '播放本集',
    playTrailer: '播放预告',
    listen: '收听',
    watch: '观看',
    latest: '最新',
    guest: '嘉宾',
    guests: '嘉宾',
    moreGuests: '更多嘉宾',
    moreGuestsCaption: '查看整季',
    hostedBy: '主持人',
    subscribe: '订阅',
    episodes: '集',
    allEpisodes: '全部单集',
    addToQueue: '从这里开始播放全部',
    left: '剩余',
    mentioned: '提到的链接',
    transcript: '文字稿',
    clip: '片段',
    shareClip: '分享此片段',
    share: '分享',
    speed: '播放速度',
    back15: '后退 15 秒',
    forward30: '前进 30 秒',
    askTitle: '向我们提问',
    sendQuestion: '发送问题',
    recordQuestion: '录制语音提问',
    leaveReview: '写评价',
    supportTitle: '支持本节目',
    becomeSupporter: '成为支持者',
    bestOfTitle: '第一次来？从这几集开始',
    bestOfText: '大家会转发给朋友的单集',
    emptyEpisodes: '还没有单集',
    emptyShows: '还没有节目',
    emptyShowLinks: '添加这个节目所在的应用',
    emptyChapters: '在单集简介里写带时间戳的行，就会生成章节',
    emptyTranscript: '把文字稿按“0:00 姓名：内容”粘贴到简介里',
    emptyClip: '添加简介 — 第一句话会成为引用',
    emptyResume: '还没有开始收听的内容',
    emptyHosts: '在单集里写上主持人，这张卡片就会填好',
    emptyGuests: '在单集里写上嘉宾，这张卡片就会填好',
    emptyTopics: '给节目加上分类，就能按主题筛选',
    emptyAsk: '添加提问语和答案的去处',
    emptyRating: '添加评分和一段可引用的评价',
    emptySupport: '添加你的支持档位',
  },
};
export const jaLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: '{count} 件中 {index} 件目を再生中',
    chapters: 'チャプター',
    transcript: '文字起こし',
    membersOnly: 'メンバー限定',
    live: 'ライブ',
    upcoming: '近日公開',
    lessonOf: 'レッスン {index}／{count}',
    days: '日',
    hours: '時間',
    minutes: '分',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: 'すべて',
    asked: '質問',
    answered: '回答',
    buy: '購入',
    resume: '続きから',
    watched: '{total} 本中 {count} 本を視聴',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: '再生中',
    mediaPlaceholder: '画像または動画',
    badgeHint: 'バッジ',
  },
  slider: {
    image: '画像',
    before: 'ビフォー',
    after: 'アフター',
  },
  wrongPage: {
    noItem: 'このページにその項目はありません',
    noBlock: 'このページにそのブロックはありません',
    question: 'このブロックがあるページに移動しますか？',
    goToPage: 'ページへ移動',
  },
  common: {
    lauching: '起動中',
    showMore: 'もっと見る',
    share: 'シェア',
  },
  bio: {
    expand: 'もっと見る',
  },
  timer: {
    days: '日',
    hours: '時間',
    min: '分',
    sec: '秒',
  },
  form: {
    email: 'メールアドレス',
    name: '名前',
    phone: '電話番号',
    comment: 'コメント（任意）',
    address: '住所',
    insta: 'Instagram アカウント',
    submitEmail: 'ご登録のメールアドレスに情報を送信しました',
    total: '合計',
    firstName: '名',
    lastName: '姓',
    enterName: '姓名',
    enterEmail: 'メールアドレス',
    enterAddress: '住所',
    enterComment: 'コメントを入力（任意）',
    thankYou: 'ありがとうございます！',
    error: '問題が発生しました',
    successEmail: 'メールアドレスが正常に送信されました',
    successPhone: '電話番号が正常に送信されました',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: 'ステップ {current}/{total}',
    back: '戻る',
    next: '次へ',
    day: '日付',
    time: '時間',
    chooseFile: 'ファイルを選択',
    uploading: 'アップロード中…',
    uploaded: 'アップロード済み',
    uploadFailed: 'アップロード失敗',
    uploadTooLarge: 'サイズ超過',
    uploadLimit: '最大 {size} MB',
    removeFile: '削除',
    sending: '送信中…',
    sentTitle: 'メッセージを送信しました',
    sendAnother: 'もう一度送る',
    closedTitle: '受付は終了しました',
    closedText: '',
  },
  basket: {
    addItem: 'カートに追加',
    itemAdded: 'カートに追加しました',
    orderNow: '今すぐ注文',
    goToCart: 'カートへ',
    continue: '買い物を続ける',
    shoppingCart: 'ショッピングカート',
    submitOrder: '注文を確定する',
    cancel: 'キャンセル',
    items: '商品',
    total: '合計',
    shipping: '配送',
    shippingName: '姓名を入力してください',
    shippingEmail: 'メールアドレスを入力してください',
    shippingAddress: '住所を入力してください',
    shippingComment: 'コメントを入力してください（任意）',
    paymentMethod: 'お支払い方法',
    stripe: 'Stripe で支払う',
    wayforpay: 'デビットカードまたはクレジットカード',
    cash: '現金',
    buttonProcessOrder: '注文を処理する',
    titleEmpty: 'カートは空です',
    subtitleEmpty: 'まだカートに何も追加されていないようです',
    bthShopNow: '今すぐ購入',
    successOrder: '注文が正常に送信されました！',
    errorOrder: '注文を送信できませんでした',
    bthHome: 'ホームへ戻る',
    quantity: '数量',
  },
  contacts: {
    ask: 'お問い合わせ：',
    orderWhatsApp: 'WhatsApp で注文',
  },
  features: {
    swipe: 'スワイプ',
    more: '詳しく見る',
  },
  // Not translated yet — English until a translation lands (this file has no EN fallback).
  team: {
    getInTouch: 'Get in touch',
    profile: 'Profile',
    people: 'people',
    swipe: 'Swipe',
    otherPeople: 'Also here',
  },
  donation: {
    textBuy: '購入',
    fieldComment: 'ひとことどうぞ…（任意）',
    buttonSupport: '支援する',
  },
  category: {
    all: 'すべて',
    noItems: '項目がありません',
  },
  // Not translated yet — English until a translation lands.
  blog: {
    read: 'Read',
    min: 'min',
    minRead: 'min read',
    all: 'All',
    pinned: 'Pinned',
    showMore: 'Show more',
  },
  // Not translated yet — English until a translation lands.
  faq: {
    noResults: 'Nothing matches that search',
  },
  // Not translated yet — English until a translation lands.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  // Not translated yet — English until a translation lands.
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Ask anything...',
      continueChat: 'Continue chat',
      noResponse: 'No response',
      sendError: 'Something went wrong. Please try again.',
      defaultBubbleTitle: 'AI Chat',
      launchLabel: 'Start the conversation',
      startChatLabel: 'Start a chat',
    },
  },
  link: {
    visitLink: 'リンクを開く',
  },
  map: {
    directions: 'ルートを表示',
    copyAddress: '住所をコピー',
    call: '電話する',
    deliveryAddress: '住所を入力',
    deliveryCheck: '距離を確認',
    searchPoint: '最も近い店舗を検索',
  },
  // Not translated yet — English until a translation lands.
  gallery: {
    photos: 'photos',
    photo: 'photo',
    all: 'All',
    open: 'Open',
    openGallery: 'Open the gallery',
  },
  pageList: {
    navigation: 'ナビゲーション',
    previous: '前へ',
    next: '次へ',
    // Not translated yet — English until a translation lands.
    allPages: 'All pages of this section',
  },
  footer: {
    subscribe: '購読する',
    subscribed: 'ありがとうございます。登録しました。',
    emailPlaceholder: 'you@email.com',
    app: 'アプリ',
    payment: 'お支払い',
    language: '言語',
    currencyAndShipping: '通貨と配送',
    messengers: 'メッセンジャー',
  },
  error: {
    correctEmail: '正しいメールアドレスを入力してください',
    emptyField: 'この項目は空にできません',
  },
  sort: {
    title: '並べ替え',
    search: '検索',
    default: 'デフォルトの並び順',
    dateNew: '日付：新しい順',
    dateOld: '日付：古い順',
    priceLow: '価格：安い順',
    priceHigh: '価格：高い順',
    nameA: '名前：A→Z',
    nameZ: '名前：Z→A',
  },
  shop: {
    notify: '入荷通知を受け取る',
    itemsLeft: '点在庫あり',
    notAvailable: '在庫なし',
    available: '在庫あり',
    similar: 'こちらもおすすめ',
    similarEmpty: '類似商品が見つかりませんでした',
  },
  file: {
    download: 'ダウンロード',
    get: '取得',
    current: '最新版',
    files: '件',
    gateTitle: 'ファイルを受け取る',
    gateText: 'メールアドレスを入力すると、ここでダウンロードできます。',
    gateAction: 'ファイルを表示',
    gateNote: 'メールアドレスはこのページの管理者にのみ届きます。',
    largeFile: 'サイズが大きいため Wi-Fi を推奨します。',
    startDownload: 'ダウンロードを開始',
    kindDocument: 'ドキュメント',
    kindImage: '画像',
    kindVideo: '動画',
    kindAudio: '音声',
    kindArchive: 'アーカイブ',
    kindOther: 'その他のファイル',
  },
  music: {
    play: '再生',
    pause: '一時停止',
    previous: '前へ',
    next: '次へ',
    listen: '聴く',
    listenOn: '聴く:',
    download: 'ダウンロード',
    presave: '事前保存',
    buy: '購入',
    on: '·',
    tracksCount: '曲',
    tracklist: 'トラックリスト',
    upNext: '次に再生',
    newSingle: 'ニューシングル',
    addToBasket: 'カートに追加',
    preview: 'プレビュー',
    hoursShort: '時間',
    minutesShort: '分',
    emptyTracks: 'トラックがまだありません',
    emptyReleases: 'リリースがまだありません',
    emptyReleaseLinks: 'ストリーミングリンクがまだありません',
    emptyPlaylists: 'プレイリストがまだありません',
  },
  podcast: {
    play: '再生',
    pause: '一時停止',
    playEpisode: 'エピソードを再生',
    playTrailer: '予告編を再生',
    listen: '聴く',
    watch: '見る',
    latest: '最新',
    guest: 'ゲスト',
    guests: 'ゲスト',
    moreGuests: 'ほかのゲスト',
    moreGuestsCaption: 'シーズン全体を見る',
    hostedBy: '出演',
    subscribe: 'フォロー',
    episodes: 'エピソード',
    allEpisodes: 'すべてのエピソード',
    addToQueue: 'ここからすべて再生',
    left: '残り',
    mentioned: '紹介したもの',
    transcript: '書き起こし',
    clip: 'クリップ',
    shareClip: 'このクリップを共有',
    share: '共有',
    speed: '再生速度',
    back15: '15秒戻る',
    forward30: '30秒進む',
    askTitle: '質問を募集中',
    sendQuestion: '質問を送る',
    recordQuestion: '音声で質問する',
    leaveReview: 'レビューを書く',
    supportTitle: '番組を支援する',
    becomeSupporter: 'サポーターになる',
    bestOfTitle: 'はじめての方はこちらから',
    bestOfText: '友だちに送りたくなるエピソード',
    emptyEpisodes: 'エピソードがまだありません',
    emptyShows: '番組がまだありません',
    emptyShowLinks: 'この番組を配信しているアプリを追加してください',
    emptyChapters: 'エピソードのノートにタイムスタンプ付きの行を書くとチャプターになります',
    emptyTranscript: 'ノートに「0:00 名前: セリフ」の形式で書き起こしを貼り付けてください',
    emptyClip: 'ノートを追加すると、最初の一文が引用になります',
    emptyResume: 'まだ何も再生していません',
    emptyHosts: 'エピソードにホスト名を入れるとこのカードが埋まります',
    emptyGuests: 'エピソードにゲスト名を入れるとこのカードが埋まります',
    emptyTopics: '番組にカテゴリーを付けるとテーマで絞り込めます',
    emptyAsk: '質問文と回答の送り先を追加してください',
    emptyRating: '評価と引用するレビューを追加してください',
    emptySupport: '支援プランを追加してください',
  },
};
export const huLang = {
  // Generic wording the Video block's templates print around the owner's own copy.
  video: {
    playing: '{count} videóból a(z) {index}. játszik',
    chapters: 'Fejezetek',
    transcript: 'Átirat',
    membersOnly: 'Csak tagoknak',
    live: 'ÉLŐ',
    upcoming: 'Hamarosan',
    lessonOf: '{count} leckéből a(z) {index}.',
    days: 'nap',
    hours: 'óra',
    minutes: 'perc',
  },
  // Generic wording the Shorts block's templates print around the owner's own copy.
  shorts: {
    all: 'Összes',
    asked: 'Kérdés',
    answered: 'Válasz',
    buy: 'Megveszem',
    resume: 'Folytatás',
    watched: '{count} / {total} megtekintve',
  },
  // What the banner's cover templates print when the user left the field empty.
  banner: {
    playing: 'Játszik',
    mediaPlaceholder: 'Kép vagy videó',
    badgeHint: 'Címke',
  },
  slider: {
    image: 'Kép',
    before: 'Előtte',
    after: 'Utána',
  },
  wrongPage: {
    noItem: 'Ilyen elem nincs ezen az oldalon',
    noBlock: 'Ilyen blokk nincs ezen az oldalon',
    question: 'Ugrás az oldalra, ahol ez a blokk található?',
    goToPage: 'Ugrás az oldalra',
  },
  common: {
    lauching: 'Indítás',
    showMore: 'Több megjelenítése',
    share: 'Megosztás',
  },
  bio: {
    expand: 'Több megjelenítése',
  },
  timer: {
    days: 'Nap',
    hours: 'Óra',
    min: 'Perc',
    sec: 'Másodperc',
  },
  form: {
    email: 'E-mail',
    name: 'Név',
    phone: 'Telefon',
    comment: 'Megjegyzés (opcionális)',
    address: 'Cím',
    insta: 'Instagram fiók',
    submitEmail: 'Elküldtük az információt az e-mail címére',
    total: 'Összesen',
    firstName: 'Keresztnév',
    lastName: 'Vezetéknév',
    enterName: 'Teljes név',
    enterEmail: 'E-mail',
    enterAddress: 'Cím',
    enterComment: 'Írjon megjegyzést (opcionális)',
    thankYou: 'Köszönjük!',
    error: 'Valami hiba történt',
    successEmail: 'Az e-mail címét sikeresen elküldtük',
    successPhone: 'A telefonszámát sikeresen elküldtük',

    // Form block templates: the multi-step bar, the schedule legends, the upload chip,
    // and the sending / sent / closed states.
    step: '{current}. lépés / {total}',
    back: 'Vissza',
    next: 'Tovább',
    day: 'Nap',
    time: 'Időpont',
    chooseFile: 'Fájl kiválasztása',
    uploading: 'Feltöltés…',
    uploaded: 'feltöltve',
    uploadFailed: 'a feltöltés nem sikerült',
    uploadTooLarge: 'túl nagy',
    uploadLimit: 'legfeljebb {size} MB',
    removeFile: 'Eltávolítás',
    sending: 'Küldés…',
    sentTitle: 'Az üzenet elment',
    sendAnother: 'Küldés újra',
    closedTitle: 'A beküldés lezárult',
    closedText: '',
  },
  basket: {
    addItem: 'Kosárba',
    itemAdded: 'Kosárba téve',
    orderNow: 'Rendelés most',
    goToCart: 'Ugrás a kosárhoz',
    continue: 'Vásárlás folytatása',
    shoppingCart: 'Kosár',
    submitOrder: 'Rendelés leadása',
    cancel: 'Mégse',
    items: 'Termékek',
    total: 'Összesen',
    shipping: 'Szállítás',
    shippingName: 'Adja meg teljes nevét',
    shippingEmail: 'Adja meg e-mail címét',
    shippingAddress: 'Adja meg címét',
    shippingComment: 'Adjon meg megjegyzést (opcionális)',
    paymentMethod: 'Fizetési mód',
    stripe: 'Fizetés Stripe-pal',
    wayforpay: 'Betéti vagy hitelkártya',
    cash: 'Készpénz',
    buttonProcessOrder: 'Rendelés feldolgozása',
    titleEmpty: 'A kosara üres',
    subtitleEmpty: 'Úgy tűnik, még nem adott hozzá semmit a kosárhoz',
    bthShopNow: 'Vásárlás most',
    successOrder: 'A rendelését sikeresen elküldtük!',
    errorOrder: 'A rendelését nem sikerült elküldeni',
    bthHome: 'Vissza a főoldalra',
    quantity: 'Mennyiség',
  },
  contacts: {
    ask: 'Kérdezzen itt:',
    orderWhatsApp: 'Rendelés WhatsAppon',
  },
  features: {
    swipe: 'Csúsztasson',
    more: 'Tudjon meg többet',
  },
  // Not translated yet — English until a translation lands (this file has no EN fallback).
  team: {
    getInTouch: 'Get in touch',
    profile: 'Profile',
    people: 'people',
    swipe: 'Swipe',
    otherPeople: 'Also here',
  },
  donation: {
    textBuy: 'Vásárlás',
    fieldComment: 'Írjon néhány kedves szót...(opcionális)',
    buttonSupport: 'Támogatás',
  },
  category: {
    all: 'Összes',
    noItems: 'Nincsenek elemek',
  },
  // Not translated yet — English until a translation lands.
  blog: {
    read: 'Read',
    min: 'min',
    minRead: 'min read',
    all: 'All',
    pinned: 'Pinned',
    showMore: 'Show more',
  },
  // Not translated yet — English until a translation lands.
  faq: {
    noResults: 'Nothing matches that search',
  },
  // Not translated yet — English until a translation lands.
  overview: {
    open: 'Open',
    closed: 'Closed',
    closingSoon: 'Closing soon',
    openingSoon: 'Opens soon',
    open24: 'Open 24 hours',
    open24Detail: 'Every day, all day',
    byAppointment: 'By appointment',
    byAppointmentDetail: 'Book a slot to visit',
    temporarilyClosed: 'Temporarily closed',
    permanentlyClosed: 'Permanently closed',
    permanentlyClosedDetail: 'This place has shut down',
    hoursUnknown: 'Hours not listed',
    hoursUnknownDetail: 'Call ahead to check',

    closesAt: 'Closes {time}',
    closesInMinutes: 'Closes in {minutes} min',
    opensAt: 'Opens {time}',
    opensInMinutes: 'Opens in {minutes} min · {time}',
    opensTomorrow: 'Opens {time} tomorrow',
    opensOnDay: 'Opens {day} {time}',
    until: 'Until',
    tomorrow: 'Tomorrow',

    directions: 'Directions',
    getDirections: 'Get directions',
    call: 'Call',
    copyAddress: 'Copy address',
    otherLocation: 'Other location',
    busyHours: 'Busy hours',
    popularEmpty: 'No busy hours added yet',

    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday',
    sun: 'Sunday',
  },
  // Not translated yet — English until a translation lands.
  blocks: {
    'chat-ai': {
      inputPlaceholder: 'Ask anything...',
      continueChat: 'Continue chat',
      noResponse: 'No response',
      sendError: 'Something went wrong. Please try again.',
      defaultBubbleTitle: 'AI Chat',
      launchLabel: 'Start the conversation',
      startChatLabel: 'Start a chat',
    },
  },
  link: {
    visitLink: 'Link megnyitása',
  },
  map: {
    directions: 'Útvonaltervezés',
    copyAddress: 'Cím másolása',
    call: 'Hívás',
    deliveryAddress: 'Írja be a címét',
    deliveryCheck: 'Távolság ellenőrzése',
    searchPoint: 'Legközelebbi helyszín keresése',
  },
  // Not translated yet — English until a translation lands.
  gallery: {
    photos: 'photos',
    photo: 'photo',
    all: 'All',
    open: 'Open',
    openGallery: 'Open the gallery',
  },
  pageList: {
    navigation: 'Navigáció',
    previous: 'Előző',
    next: 'Következő',
    // Not translated yet — English until a translation lands.
    allPages: 'All pages of this section',
  },
  footer: {
    subscribe: 'Feliratkozás',
    subscribed: 'Köszönjük — felkerültél a listára.',
    emailPlaceholder: 'you@email.com',
    app: 'Alkalmazás',
    payment: 'Fizetés',
    language: 'Nyelv',
    currencyAndShipping: 'Pénznem és szállítás',
    messengers: 'Üzenetküldők',
  },
  error: {
    correctEmail: 'Adjon meg érvényes e-mail címet',
    emptyField: 'a mező nem lehet üres',
  },
  sort: {
    title: 'Rendezés',
    search: 'Keresés',
    default: 'Alapértelmezett rendezés',
    dateNew: 'Dátum: legújabb elöl',
    dateOld: 'Dátum: legrégebbi elöl',
    priceLow: 'Ár: alacsonytól a magasig',
    priceHigh: 'Ár: magastól az alacsonyig',
    nameA: 'Név: A-tól Z-ig',
    nameZ: 'Név: Z-től A-ig',
  },
  shop: {
    notify: 'Értesítést kérek',
    itemsLeft: 'darab maradt',
    notAvailable: 'Nem elérhető',
    available: 'Elérhető',
    similar: 'Ez is tetszhet',
    similarEmpty: 'Nem található hasonló termék',
  },
  file: {
    download: 'Letöltés',
    get: 'Kérem',
    current: 'Aktuális',
    files: 'fájl',
    gateTitle: 'Kérem a fájlt',
    gateText: 'Add meg az e-mail-címed, és a letöltés itt nyílik meg.',
    gateAction: 'Mutasd a fájlt',
    gateNote: 'Az e-mail-címed csak az oldal tulajdonosához jut el.',
    largeFile: 'Nagy letöltés — Wi-Fi ajánlott.',
    startDownload: 'Letöltés indítása',
    kindDocument: 'Dokumentumok',
    kindImage: 'Képek',
    kindVideo: 'Videó',
    kindAudio: 'Hang',
    kindArchive: 'Archívumok',
    kindOther: 'Egyéb fájlok',
  },
  music: {
    play: 'Lejátszás',
    pause: 'Szünet',
    previous: 'Előző',
    next: 'Következő',
    listen: 'Hallgatás',
    listenOn: 'Hallgatás:',
    download: 'Letöltés',
    presave: 'Pre-save',
    buy: 'Megvásárolom',
    on: '·',
    tracksCount: 'szám',
    tracklist: 'Számlista',
    upNext: 'Következik',
    newSingle: 'Új kislemez',
    addToBasket: 'Kosárba',
    preview: 'előnézet',
    hoursShort: 'ó',
    minutesShort: 'perc',
    emptyTracks: 'Még nincsenek számok',
    emptyReleases: 'Még nincsenek kiadványok',
    emptyReleaseLinks: 'Még nincsenek streaming linkek',
    emptyPlaylists: 'Még nincsenek lejátszási listák',
  },
  podcast: {
    play: 'Lejátszás',
    pause: 'Szünet',
    playEpisode: 'Epizód lejátszása',
    playTrailer: 'Előzetes lejátszása',
    listen: 'Meghallgatás',
    watch: 'Megnézem',
    latest: 'Legfrissebb',
    guest: 'Vendég',
    guests: 'Vendégek',
    moreGuests: 'További vendégek',
    moreGuestsCaption: 'A teljes évad',
    hostedBy: 'Műsorvezetők',
    subscribe: 'Feliratkozás',
    episodes: 'epizód',
    allEpisodes: 'Összes epizód',
    addToQueue: 'Innentől mindet lejátszom',
    left: 'maradt',
    mentioned: 'Említett',
    transcript: 'Átirat',
    clip: 'Klip',
    shareClip: 'Klip megosztása',
    share: 'Megosztás',
    speed: 'Sebesség',
    back15: '15 másodperccel vissza',
    forward30: '30 másodperccel előre',
    askTitle: 'Kérdezz bármit',
    sendQuestion: 'Kérdés küldése',
    recordQuestion: 'Hangüzenet rögzítése',
    leaveReview: 'Értékelés írása',
    supportTitle: 'Támogasd a műsort',
    becomeSupporter: 'Legyél támogató',
    bestOfTitle: 'Új itt? Kezdd ezekkel',
    bestOfText: 'Epizódok, amiket továbbküldenek',
    emptyEpisodes: 'Még nincsenek epizódok',
    emptyShows: 'Még nincsenek műsorok',
    emptyShowLinks: 'Add meg, mely appokban hallgatható a műsor',
    emptyChapters: 'Írj időbélyeges sorokat az epizód jegyzeteibe, és lesznek fejezetek',
    emptyTranscript: 'Illeszd be az átiratot a jegyzetekbe „0:00 Név: sor” formában',
    emptyClip: 'Adj jegyzetet — az első mondat lesz az idézet',
    emptyResume: 'Még semmi sem kezdődött el',
    emptyHosts: 'Nevezd meg a műsorvezetőt egy epizódnál, hogy kitöltsd a kártyát',
    emptyGuests: 'Nevezz meg egy vendéget egy epizódnál, hogy kitöltsd a kártyát',
    emptyTopics: 'Adj a műsoroknak kategóriát a téma szerinti szűréshez',
    emptyAsk: 'Add meg a kérdést és azt, hová érkeznek a válaszok',
    emptyRating: 'Add meg az értékelést és egy idézhető véleményt',
    emptySupport: 'Add meg a támogatói szinteket',
  },
};
